// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:12.682Z
// Property: Cheltenham Station (ID: 6767906449166311)
// Collections: 11 amenities, 8 floorplans (live), 9 photos, 82 POIs, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166311",
  "property_external_id": "4973269",
  "property_zillow_url": "https://www.zillow.com/apartments/philadelphia-pa/cheltenham-station/98vTfs/",
  "property_apartments_url": "https://www.apartments.com/cheltenham-station-philadelphia-pa/3vlqh7g/",
  "property_google_business_url": "https://www.google.com/maps/place/Cheltenham+Station+Apartment+Homes/data=!4m2!3m1!1s0x0:0xb1e36bd8d10939a8?sa=X&ved=2ahUKEwjDrt-ikLiSAxVZkYkEHfzHIIcQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cheltenham-station-apartments",
  "property_name": "Cheltenham Station",
  "property_website_url": "https://www.cheltenhamstationapartments.com/",
  "property_domain": "https://www.cheltenhamstationapartments.com/",
  "property_address": "6810 Martins Mill Road",
  "property_full_address": "6806 Martins Mill Rd #2828, Philadelphia, PA 19111",
  "property_address_1": "6806 Martins Mill Rd",
  "property_address_2": "2828",
  "property_address_city": "Philadelphia",
  "property_address_state": "PA",
  "property_address_zip_full": "19111-4635",
  "property_address_zip": "19111",
  "property_address_country": "US",
  "property_address_county": "Philadelphia County",
  "property_neighborhood_address": "Northeast Philadelphia",
  "property_address_latitude": "40.0557545",
  "property_address_longitude": "-75.09291209999999",
  "property_email": "wellington@aionmanagement.com",
  "property_phone": "(215) 443-7300",
  "property_call_tracking_phone": "877-740-2526",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "<p>Enjoy our newly updated studio, one-, and two-bedroom apartment homes for rent in Philadelphia, Pennsylvania.</p>",
  "property_long_description": "<p>Choose from one of our spacious floor plans and find your perfect landing place in Philadelphia at Cheltenham Station. Our pet-friendly community provides a comfortable retreat with a host of upgrades plus friendly neighborhood vibes at an affordable price. Here, you can relax and entertain in welcoming living spaces or enjoy all the nearby parks right nearby. Situated near major highways and employers, Cheltenham Station offers a lifestyle where work and play are right outside your door.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd912-20e1-7320-9cfa-5385587be8f3.webp",
  "property_featured_image_media": {
    "alt_text": "Spacious living room with a gray sofa, accent chairs, coffee table, and a dining area.",
    "public_id": "019fd912-20e1-7320-9cfa-5385587be8f3",
    "storage_key": "property/6767906449166311/019fd912-20e1-7320-9cfa-5385587be8f3.webp",
    "width": 1196,
    "height": 904
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "43",
  "property_year_built": "1970",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.67441860465115",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Security Deposit: $500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. Non‑refundable pet fee: $300. Monthly pet rent: $50 for one pet, $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://cheltenhamstation.loftliving.com/login",
  "property_apply_now_url": "https://www.cheltenhamstationapartments.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0266-fac2-744f-8bee-2c3f0ce10304.webp",
  "property_primary_logo_media": {
    "alt_text": "Cheltenham Station apartment homes logo.",
    "public_id": "019d0266-fac2-744f-8bee-2c3f0ce10304",
    "storage_key": "property/6767906449166311/019d0266-fac2-744f-8bee-2c3f0ce10304.webp",
    "width": 214,
    "height": 50
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0264-861a-700b-add7-ddf4938bac98.webp",
  "property_secondary_logo_media": {
    "alt_text": "Cheltenham Station apartment homes logo",
    "public_id": "019d0264-861a-700b-add7-ddf4938bac98",
    "storage_key": "property/6767906449166311/019d0264-861a-700b-add7-ddf4938bac98.webp",
    "width": 230,
    "height": 120
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0267-4e85-7637-8c88-d19596091492.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cheltenham Station apartment homes logo",
    "public_id": "019d0267-4e85-7637-8c88-d19596091492",
    "storage_key": "property/6767906449166311/019d0267-4e85-7637-8c88-d19596091492.webp",
    "width": 214,
    "height": 50
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0267-5689-70cf-8bf8-8fe6236cbd15.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cheltenham Station apartment homes logo",
    "public_id": "019d0267-5689-70cf-8bf8-8fe6236cbd15",
    "storage_key": "property/6767906449166311/019d0267-5689-70cf-8bf8-8fe6236cbd15.webp",
    "width": 214,
    "height": 50
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#706c6c",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "313 - 874",
  "property_sqft_min": "313",
  "property_sqft_max": "874",
  "property_price_range": "740.11 - 1575",
  "property_price_min": "740.11",
  "property_price_max": "1575",
  "property_available_units": 1,
  "property_facebook_url": "https://www.facebook.com/cheltenhamstation",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJlQn0ciC3xokRqDkJ0dhr47E",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/biz/cheltenham-station-philadelphia",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cheltenham Station Apartments",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, your perfect home awaits. Choose from stylish studio, one-bedroom, or two-bedroom layouts, featuring modern amenities like air conditioning, updated kitchens, and pet-friendly policies. Enjoy community activities, flexible rent options, and 24-hour maintenance—every detail designed for your comfort and lifestyle.",
  "property_home_floorplans_blurb": "At Cheltenham Station Apartments in vibrant Philadelphia, PA, each floor plan, from cozy studios to spacious one and two-bedroom layouts, is designed for modern living. Embrace a lifestyle of comfort and convenience. Browse our available apartment homes today and find the perfect space that fits your unique lifestyle!",
  "property_home_gallery_blurb": "Welcome to Cheltenham Station Apartments in Philadelphia, where comfort meets convenience. Choose from stylish floor plans, including studio, one, and two-bedroom options. Enjoy vibrant resident activities, pet-friendly amenities, and a modern online portal. Experience the ease of flexible rent payments and 24-hour emergency maintenance. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Cheltenham Station Apartments, vibrant living meets rich local culture in the heart of Philadelphia. Nestled near theater gems and artistic havens like the Keswick Theatre and the Cheltenham Center for the Arts, our community is designed for those who thrive on creativity and connection. Experience life surrounded by nature at the scenic Pennypack Environmental Center, just moments from home.",
  "property_home_reviews_blurb": "At Cheltenham Station Apartments in vibrant Philadelphia, residents rave about their \"truly exceptional living experience.\" Nestled within a welcoming community, our homes blend comfort and convenience seamlessly. Curious about life here? See what our residents have to say about living at our community! ",
  "property_neighborhood_blurb": "At Cheltenham Station Apartments in Philadelphia, vibrant culture and convenience blend seamlessly. Enjoy proximity to lush parks like Pennypack and Morris Arboretum, or indulge your creative side at the Abington Art Center. With excellent schools and local shops, explore the neighborhood's rich offerings that make life here truly exceptional!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, modern living meets comfort. Choose from stylish studio, one, or two-bedroom layouts, all featuring upgraded kitchens and cozy patios. Enjoy a pet-friendly community with vibrant resident activities, 24-hour maintenance, and flexible lease options. Your ideal home awaits—join us today!",
  "property_applynow_blurb": "At Cheltenham Station Apartments in Philadelphia, experience modern living with inviting floor plans, from cozy studios to spacious two-bedroom units. Enjoy pet-friendly amenities, flexible rent options, and a vibrant community atmosphere. With upgrades like a renovated kitchen and convenient online portal, your new home awaits. Lease online today!",
  "property_contactus_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, our diverse floor plans cater to every lifestyle—whether you seek the cozy charm of a studio, the spacious comfort of a one-bedroom, or the flexibility of a two-bedroom. Let our leasing team assist you in finding your perfect home. Contact us today!",
  "property_faqs_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, we offer thoughtfully designed floor plans, including cozy studios, spacious one-bedroom, and versatile two-bedroom options. Curious about our community? Visit our FAQs page to uncover answers to your questions and learn more about the lifestyle that awaits you here!",
  "property_floorplans_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, stylish living awaits! Choose from our diverse selection of floor plans, including cozy studios, spacious one-bedrooms, and expansive two-bedrooms. Each layout is designed for comfort and convenience. Browse our available apartment homes and find your ideal space today!",
  "property_gallery_blurb": "At Cheltenham Station Apartments in Philadelphia, every moment feels like home. Choose from our stylish studio, one, or two-bedroom floor plans, and enjoy amenities like a pet-friendly environment, upgraded kitchens, and vibrant resident activities. Picture yourself unwinding on your private patio—your ideal lifestyle awaits!",
  "property_interactivemap_blurb": "Welcome to Cheltenham Station Apartments in Philadelphia, where comfort meets modern living. Choose from stylish studio, one, or two-bedroom floor plans, complete with upgraded kitchens and pet-friendly perks. Enjoy a vibrant community with activities, flexible rent, and 24-hour maintenance. Use our interactive map to find your ideal home today!",
  "property_pets_blurb": "At Cheltenham Station Apartments in vibrant Philadelphia, your furry friends are part of the family! With space for two pets up to 100 lbs each, our community embraces your love for pets. Enjoy nearby parks and green spaces, making every walk a delightful adventure in your new home!",
  "property_referafriend_blurb": "At Cheltenham Station Apartments in vibrant Philadelphia, our thoughtfully designed floor plans—ranging from cozy studios to spacious two bedrooms—offer the perfect home for you and your friends. Great friends make great neighbors; refer a friend to join our welcoming community today! Invite them to experience the difference!",
  "property_residentaccess_blurb": "Welcome to Cheltenham Station Apartments in vibrant Philadelphia, PA. Choose from a range of stylish floor plans—one bedroom, two bedroom, or studio—designed for comfortable living. Ready to streamline your experience? Access your resident portal to pay rent, schedule maintenance, and enjoy hassle-free apartment living today!",
  "property_reviews_blurb": "At Cheltenham Station Apartments in Philadelphia, residents rave that living here feels like home. One satisfied tenant shares, “The sense of community is amazing!” Join a neighborhood where comfort meets connection. See what our residents have to say about living at our community!",
  "property_created_at": "1757004780494",
  "property_scheduletour_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, choose from thoughtfully designed one-bedroom, two-bedroom, and studio floor plans tailored for your lifestyle. Experience vibrant community living and everything our residents adore. Schedule a tour today and hear firsthand how Cheltenham Station feels like home!",
  "property_thankyou_blurb": "Thank you for reaching out to Cheltenham Station Apartments in vibrant Philadelphia, PA! With thoughtfully designed one-bedroom, two-bedroom, and studio floor plans, our community offers a home tailored to your lifestyle. Expect a member of our team to connect with you shortly to discuss your future in our welcoming community!",
  "property_virtualtours_blurb": "At Cheltenham Station Apartments in Philadelphia, PA, choice meets comfort with stunning one-bedroom, two-bedroom, and studio floor plans. Immerse yourself in stylish living spaces tailored to your lifestyle. Ready to see your future home? Take a virtual tour today and experience the vibrant community waiting for you!",
  "property_copyright": "2025 All Rights Reserved. Cheltenham Station Apartments",
  "property_seo_title_home": "Cheltenham Station Apartments Philadelphia, PA",
  "property_seo_description_home": "Discover Cheltenham Station, the best Apartments in Philadelphia—stylish floor plans, premium amenities, and pet-friendly living await!",
  "property_seo_title_floorplans": "Floor Plans | Philadelphia, PA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Cheltenham Station the top Apartments in Philadelphia! Choose from stylish studio, 1, or 2-bedroom floor plans with modern living.",
  "property_seo_title_amenities": "Amenities | Philadelphia, PA Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at Cheltenham Station Apartments Complex in Philadelphia! Enjoy pet-friendly spaces, modern amenities, and flexible leasing. Join us!",
  "property_seo_title_gallery": "Gallery | Apartments for rent in Philadelphia, PA",
  "property_seo_description_gallery": "Step into Cheltenham Station Apartments, where modern living meets comfort. View stunning spaces, enjoy pet-friendly amenities, and envision your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | Cheltenham Station Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Cheltenham Station Apartments in Philadelphia. Take a virtual tour of our stylish studio, one, and two-bedroom layouts today!",
  "property_seo_title_interactivemap": "Interactive Map | Cheltenham Station Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Cheltenham Station Apartments in Philadelphia! Use our interactive map to explore stunning layouts and enjoy pet-friendly amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments for rent near Philadelphia",
  "property_seo_description_neighborhood": "Uncover hidden gems and local favorites around Cheltenham Station Apartments in Philadelphia, PA. Experience vibrant living in a thriving neighborhood today!",
  "property_seo_title_contact": "Contact Us Cheltenham Station Apartments Complex for rent",
  "property_seo_description_contact": "Reach out to the Cheltenham Station Apartments team in Philadelphia, PA! From one to two-bedroom units, find your perfect home—connect with us now!",
  "property_seo_title_faqs": "FAQs | Apartments in Philadelphia, PA",
  "property_seo_description_faqs": "Got questions about Cheltenham Station Apartments in Philly? Our FAQs cover everything from pet policies to amenities. Get the answers you need today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Philadelphia, PA",
  "property_seo_description_reviews": "Experience life at Cheltenham Station Apartments in Philadelphia! Uncover what our residents love about their homes and community amenities. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Philadelphia, PA",
  "property_seo_description_applynow": "Discover your ideal home at Cheltenham Station Apartments! Stylish, pet-friendly, and convenient leasing. Apply today!",
  "property_seo_title_residentaccess": "Resident Access | Cheltenham Station Apartments",
  "property_seo_description_residentaccess": "Seamlessly manage your Cheltenham Station home. Log in to your resident portal for easy rent payments, maintenance requests, and community updates in Philly!",
  "property_seo_title_referafriend": "Refer A Friend | Cheltenham Station Apartments",
  "property_seo_description_referafriend": "Refer a friend to Cheltenham Station Apartments in Philadelphia, PA! Great friends make great neighbors—share the joy of our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cheltenham Station Apartments",
  "property_seo_description_scheduletour": "Experience life at Cheltenham Station Apartments in Philadelphia! Schedule a tour today to see your future home nestled in comfort and convenience.",
  "property_seo_title_privacy": "Privacy Policy | Cheltenham Station Apartments",
  "property_seo_description_privacy": "At Cheltenham Station Apartments, your privacy matters. Discover how we protect your information—read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Cheltenham Station Apartments",
  "property_seo_description_accessibility": "Experience seamless living at Cheltenham Station Apartments in Philadelphia, where accessibility meets comfort. Join us in embracing digital inclusion for all!",
  "property_seo_title_sitemap": "Sitemap | Cheltenham Station Apartments",
  "property_seo_description_sitemap": "Uncover the layout of Cheltenham Station Apartments in Philadelphia, PA. Navigate easily with our sitemap and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Cheltenham Station Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Cheltenham Station Apartments in Philadelphia! Our team is excited to connect and help you find your new home sweet home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Philadelphia, PA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293636663",
  "amenities": [
    {
      "id": "custom_8fc21561-5f74-4d60-ba88-b3c932de130e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_90cd8e54-b2d9-41c5-952c-fb257073131d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_14e87a42-cf1e-439a-9343-e4a0eaaf5ffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dbd02d5-bece-493b-a317-6e587d99ab32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c5e2a1e-f9f0-412c-8cdf-245e59b1d1f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_739baa15-5c16-44ae-8baf-5e576e33088d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Short-Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_eec8f6c6-f409-4842-a6a4-03dce9a77406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3b1c8c04-d558-432f-be12-b202df095666",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f6a83af-3049-401f-b5be-bfd17a08408d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Vinyl Hardwood Floors*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c444eda7-88eb-466b-a228-074c0b225728",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "Walk to Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_258a5ab2-5748-4f08-91a8-f597de11101b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_ed09e490-fbae-4e5d-9ab3-458b4e8e5789",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-8602-76f9-9ba7-810c050ba28d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets.",
        "public_id": "019fd920-8602-76f9-9ba7-810c050ba28d",
        "storage_key": "property/6767906449166311/019fd920-8602-76f9-9ba7-810c050ba28d.webp",
        "width": 1024,
        "height": 819
      },
      "title": "Community",
      "description": "Updated Kitchen",
      "link": "false",
      "alt_text": "Compact kitchen with black appliances, white cabinets, and dark countertops in an L-shaped layout",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/Cheltenham+Kitchen-1920w.jpeg"
    },
    {
      "id": "custom_81c49b79-bb9a-4686-8e39-92f0bb8ac42d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-85c6-722a-9149-43e1f4dbcd35.webp",
      "image_media": {
        "alt_text": "Living room with two sofas, a coffee table, and a dining area visible.",
        "public_id": "019fd920-85c6-722a-9149-43e1f4dbcd35",
        "storage_key": "property/6767906449166311/019fd920-85c6-722a-9149-43e1f4dbcd35.webp",
        "width": 1196,
        "height": 904
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Living room with two gray sofas, a round coffee table, patterned rug, and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/beb2fe879bc385f658997d2ad7c97a5c-1920w.jpg"
    },
    {
      "id": "custom_d7e5a092-f877-4ea2-afa8-151907bd35fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-85fe-7642-a266-67a4430de42a.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet, nightstand, lamp, and a bed.",
        "public_id": "019fd920-85fe-7642-a266-67a4430de42a",
        "storage_key": "property/6767906449166311/019fd920-85fe-7642-a266-67a4430de42a.webp",
        "width": 1202,
        "height": 908
      },
      "title": "Community",
      "description": "Interior",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a bed, closet, dresser, lamp, and a potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/6c70fe1b7eccf8221262e10e8a12a5e3-1920w.jpg"
    },
    {
      "id": "custom_89f99f38-9b25-488c-87d9-f9c40938164b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-8638-77ab-aba0-0c93e1ef8929.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, TV, and a closet.",
        "public_id": "019fd920-8638-77ab-aba0-0c93e1ef8929",
        "storage_key": "property/6767906449166311/019fd920-8638-77ab-aba0-0c93e1ef8929.webp",
        "width": 1204,
        "height": 909
      },
      "title": "Community",
      "description": "Furnished living area in a modern apartment with a sectional sofa, TV stand, coffee table, and closet.",
      "link": "false",
      "alt_text": "Living room in a modern apartment with a sectional sofa, TV, and a closet visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/54030e0ff49616dc93a3e74cb1b14477-1920w.jpg"
    },
    {
      "id": "custom_c718a0e2-bb09-4986-b9a1-3bf2e06c9f89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-913b-70ca-ba00-e89591474006.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs next to a kitchen and a desk.",
        "public_id": "019fd920-913b-70ca-ba00-e89591474006",
        "storage_key": "property/6767906449166311/019fd920-913b-70ca-ba00-e89591474006.webp",
        "width": 1271,
        "height": 960
      },
      "title": "Community",
      "description": "Cozy apartment dining and kitchen space with a white table, beige walls, and a small wooden desk nearby.",
      "link": "false",
      "alt_text": "Dining area with a white table and chairs beside a compact kitchen with beige walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/4daea5b87ef1058de8b06ad966cbdc6f-1920w.jpg"
    },
    {
      "id": "custom_e1bf8c71-4c0c-445c-b342-a04402ab50fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-9344-7112-85bd-e4d835dae489.webp",
      "image_media": {
        "alt_text": "Kitchen with black gas range, stainless steel refrigerator, and white cabinets.",
        "public_id": "019fd920-9344-7112-85bd-e4d835dae489",
        "storage_key": "property/6767906449166311/019fd920-9344-7112-85bd-e4d835dae489.webp",
        "width": 1251,
        "height": 945
      },
      "title": "Interior",
      "description": "Cozy apartment kitchen with stainless refrigerator, gas range, white cabinets, and light wood trim.",
      "link": "false",
      "alt_text": "Compact apartment kitchen with beige walls, white upper cabinets, and a stainless steel refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/9f76a802789b498178dfbee2848815c1-1920w.jpg"
    },
    {
      "id": "custom_0e97bae8-765b-42f0-801e-50c34ca2320a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-936d-75eb-8008-1bcdf35661f8.webp",
      "image_media": {
        "alt_text": "Corner kitchen with stainless steel refrigerator, black gas stove, and white cabinets.",
        "public_id": "019fd920-936d-75eb-8008-1bcdf35661f8",
        "storage_key": "property/6767906449166311/019fd920-936d-75eb-8008-1bcdf35661f8.webp",
        "width": 1271,
        "height": 960
      },
      "title": "Interior",
      "description": "Cozy apartment kitchen with a gas range, stainless fridge, and upper/lower cabinets; sunflowers add a cheerful touch.",
      "link": "false",
      "alt_text": "Compact apartment kitchen with gas range, sink, and a stainless steel refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/0e7446a3a04e17a4f3ac8b6ab30ba40e-1920w.jpg"
    },
    {
      "id": "custom_d47c5868-5894-4b9c-acc1-f46f2bcfafb5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-966e-71fb-b59d-726e1f0f526c.webp",
      "image_media": {
        "alt_text": "Pink bathtub with white tiled walls and a grey shower curtain.",
        "public_id": "019fd920-966e-71fb-b59d-726e1f0f526c",
        "storage_key": "property/6767906449166311/019fd920-966e-71fb-b59d-726e1f0f526c.webp",
        "width": 914,
        "height": 1210
      },
      "title": "Interior",
      "description": "Apartment bathroom featuring a pink tub, retro tile design, and a gray shower curtain.",
      "link": "false",
      "alt_text": "Pink-tiled bathroom with a pink tub, tile walls, and a gray shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/0e8a1c059b53e62078b87698d7e64209-1920w.jpg"
    },
    {
      "id": "custom_fa1d1c14-6f06-4e8d-a5af-c24aa7feff36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-9d9f-7157-a45b-2ccf99991e5f.webp",
      "image_media": {
        "alt_text": "Balcony with two white wicker chairs, lush green trees in background.",
        "public_id": "019fd920-9d9f-7157-a45b-2ccf99991e5f",
        "storage_key": "property/6767906449166311/019fd920-9d9f-7157-a45b-2ccf99991e5f.webp",
        "width": 1162,
        "height": 878
      },
      "title": "Interior",
      "description": "Interior",
      "link": "false",
      "alt_text": "Balcony with white wicker chairs and cushions, overlooking trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/10e33b91/dms3rep/multi/opt/5767906449162442/6767906449166311/2d08d1712ee8e909ef4922767617ac91-1920w.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_af9848df-55f4-4449-be08-6d9a3955c47b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "SHANAS CARIBBEAN CAFE",
      "poi_type": "Restaurants",
      "poi_address": "6615 Martins Mill Rd, Philadelphia, PA 19111, USA",
      "poi_short_description": "Casual restaurant serving Jamaican comfort food, including popular jerk chicken, oxtail, and mac and cheese.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-cbde-7016-ad23-ced7c53d6e53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-cbde-7016-ad23-ced7c53d6e53",
        "storage_key": "property/6767906449166311/019fd91e-cbde-7016-ad23-ced7c53d6e53.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://shanascaribbeancafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14935513720256459182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shanas-caribbean-cafe",
      "poi_latitude": "40.0526621",
      "poi_longitude": "-75.09189289999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 215-716-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5VisCu3xokRrvHbyZiaRc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8096a097-3962-4939-86cd-72028fd5c963",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Martha’s Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "6615 Martins Mill Rd, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-f961-76d3-9933-0cd6d709ad02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-f961-76d3-9933-0cd6d709ad02",
        "storage_key": "property/6767906449166311/019fd91e-f961-76d3-9933-0cd6d709ad02.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.marthaskitchen723.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16543909904815915968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marthas-kitchen",
      "poi_latitude": "40.05265199999999",
      "poi_longitude": "-75.0918648",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 267-408-2539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2X2B3FO3xokRwIOesGfGl-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8d65688-e91a-4703-b9e7-36041bd8d8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Philly Munchies • Exotic Snacks",
      "poi_type": "Restaurants",
      "poi_address": "6445 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-c969-7019-aa9d-9b6bd8bedb66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-c969-7019-aa9d-9b6bd8bedb66",
        "storage_key": "property/6767906449166311/019fd91e-c969-7019-aa9d-9b6bd8bedb66.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.doordash.com/store/philly-munchies-and-groceries-philadelphia-26138463/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1453283016731533040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philly-munchies--exotic-snacks-smoke-shop--convenience-store",
      "poi_latitude": "40.0507376",
      "poi_longitude": "-75.0940791",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 267-968-3689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0R0ZckK3xokR8B5kMjQZKxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_44afb02e-a99b-469d-bde1-01af0d335e14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Soul of Africa Restaurant LLC",
      "poi_type": "Restaurants",
      "poi_address": "6422 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Liberian and other West African dishes such as cassava stew, peanut soup and fufu.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-c245-778a-8b01-ea5ee1dd2f78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-c245-778a-8b01-ea5ee1dd2f78",
        "storage_key": "property/6767906449166311/019fd91e-c245-778a-8b01-ea5ee1dd2f78.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://soulofafricarestaurant.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=9465831501009207183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "soul-of-africa-restaurant-llc",
      "poi_latitude": "40.050405",
      "poi_longitude": "-75.095128",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-331-3014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3geLXu3xokRjz9bGZljXYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eea0530d-d344-4983-a1de-31d6482e0afb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Quality Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6438 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Laid-back spot doling out pizzas and other Italian grub, such as sandwiches, hoagies, and calzones.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-dcfc-7349-ba2d-9ebfe1d82d2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-dcfc-7349-ba2d-9ebfe1d82d2d",
        "storage_key": "property/6767906449166311/019fd91e-dcfc-7349-ba2d-9ebfe1d82d2d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.qualitypizzamenu.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1928849357379675654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quality-pizza",
      "poi_latitude": "40.0509541",
      "poi_longitude": "-75.0946309",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-742-1107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZDNnsK2xokRBibbY0WmxBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e0a9b2c5-7ef5-4a0a-bf83-1b347cd4806c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Golden Garden",
      "poi_type": "Restaurants",
      "poi_address": "6611 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Relaxed restaurant dishing up familiar Chinese fare such as General Tso's chicken, and crab rangoon.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-df1d-74d8-985b-5458350e7c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-df1d-74d8-985b-5458350e7c78",
        "storage_key": "property/6767906449166311/019fd91e-df1d-74d8-985b-5458350e7c78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12813148876138385569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "false",
      "poi_latitude": "40.052374",
      "poi_longitude": "-75.09268",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-742-6730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ20dUUMK2xokRoZBsEARz0bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e273ad17-43b6-4813-8882-cc128f3387af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Larry's Famous Steaks & Hoagies",
      "poi_type": "Restaurants",
      "poi_address": "6400 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Longtime counter-service shop serving up classic cheesesteaks, hoagies, pizza & wings.",
      "poi_long_description": "Longtime counter-service shop serving up classic cheesesteaks, hoagies, pizza & wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-e057-71d6-891f-53bfb5011194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-e057-71d6-891f-53bfb5011194",
        "storage_key": "property/6767906449166311/019fd91e-e057-71d6-891f-53bfb5011194.webp",
        "width": 1280,
        "height": 900
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=43505843772144298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "larrys-famous-steaks--hoagies",
      "poi_latitude": "40.0499014",
      "poi_longitude": "-75.0957736",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-722-2400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm6UfDOi2xokRqjqxm1WQmgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db1f12af-d52f-48c8-bfe4-106593a248b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Rising Sun Pizza",
      "poi_type": "Restaurants",
      "poi_address": "6919 Rising Sun Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Informal option for pizza, strombolis, cheesesteaks & more in basic surrounds, plus delivery.",
      "poi_long_description": "Informal option for pizza, strombolis, cheesesteaks & more in basic surrounds, plus delivery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-f764-7439-b7eb-8227c213e30d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-f764-7439-b7eb-8227c213e30d",
        "storage_key": "property/6767906449166311/019fd91e-f764-7439-b7eb-8227c213e30d.webp",
        "width": 1280,
        "height": 787
      },
      "poi_business_url": "https://risingsun.pizza/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9041848056612211757&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rising-sun-pizza",
      "poi_latitude": "40.0566128",
      "poi_longitude": "-75.0883853",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 215-342-4224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvydO7sa2xokRLUxt1-YYe30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_70c8ab5f-9d47-484c-9211-2e76429a1db7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Verree Express Pizza",
      "poi_type": "Restaurants",
      "poi_address": "7959 Verree Rd, Philadelphia, PA 19111, USA",
      "poi_short_description": "Pizzeria offering chicken wings, cheesesteaks, and other sides, with fast delivery service.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-f6fe-7461-a5c4-3f6e43ab5632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-f6fe-7461-a5c4-3f6e43ab5632",
        "storage_key": "property/6767906449166311/019fd91e-f6fe-7461-a5c4-3f6e43ab5632.webp",
        "width": 1280,
        "height": 839
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15965947820362262195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "verree-express-pizza",
      "poi_latitude": "40.0724186",
      "poi_longitude": "-75.07604649999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-745-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06vrqOCxxokRs2Ydj_Nwkt0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_47a40f36-6e21-4dce-8d62-c7d5614ea772",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Bishos",
      "poi_type": "Restaurants",
      "poi_address": "7950 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Neighborhood restaurant specializing in Middle Eastern eats including shish kebabs, hummus, falafel and baklava pastries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91e-f543-705f-885f-6f3cbb0f6907.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91e-f543-705f-885f-6f3cbb0f6907",
        "storage_key": "property/6767906449166311/019fd91e-f543-705f-885f-6f3cbb0f6907.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://mybishos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12474058052986407762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bishos",
      "poi_latitude": "40.0758304",
      "poi_longitude": "-75.0851789",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-660-9760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsW3cJx-0xokRUgvbc7XBHK0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d348d316-6f3f-46de-8477-10d687aa38ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Moonstruck Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2271954579839057048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moonstruck-restaurant",
      "poi_latitude": "40.0761792",
      "poi_longitude": "-75.08495719999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXfKzJTaxxokRmPwgLaeahx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bdbd3e6d-e350-450e-a13b-472698b294de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Panda Express Wyncote",
      "poi_type": "Restaurants",
      "poi_address": "2401 W Cheltenham Ave Ste 130, Wyncote, PA 19095, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-095b-7658-b061-40389c51cc7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-095b-7658-b061-40389c51cc7f",
        "storage_key": "property/6767906449166311/019fd91f-095b-7658-b061-40389c51cc7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.pandaexpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3511743184843872697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express-wyncote",
      "poi_latitude": "40.0741148",
      "poi_longitude": "-75.15541209999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-881-8928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVYrKPe3xokRuZkEE9I3vDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_85c3a832-1774-4d94-8698-59b5468cf947",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "2401 W Cheltenham Ave, Wyncote, PA 19095, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-06b6-73e7-aa38-6d85d7ff0fb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-06b6-73e7-aa38-6d85d7ff0fb2",
        "storage_key": "property/6767906449166311/019fd91f-06b6-73e7-aa38-6d85d7ff0fb2.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://locations.chipotle.com/pa/wyncote/2401-w-cheltenham-ave?utm_source=google&utm_medium=yext&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=17394964088050493136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "40.0735837",
      "poi_longitude": "-75.1548936",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-884-2695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH6Dbxdi5xokR0Cbt9KxTZ_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5271179e-7b92-48d8-b7e3-f6b0fed5591a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Four Seasons Diner Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "2811 Cottman Ave, Philadelphia, PA 19149, USA",
      "poi_short_description": "Classic eatery with counter serving American fare, including breakfast, lunch & dinner, 24/7.",
      "poi_long_description": "Classic eatery with counter serving American fare, including breakfast, lunch & dinner, 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-0a70-72bc-8a5b-8eb4fb135e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-0a70-72bc-8a5b-8eb4fb135e1f",
        "storage_key": "property/6767906449166311/019fd91f-0a70-72bc-8a5b-8eb4fb135e1f.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://fsdiner.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15779917213304170199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "four-seasons-diner-restaurant",
      "poi_latitude": "40.0441435",
      "poi_longitude": "-75.0530576",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-331-0797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSddtQiK0xokR1yYRlBmH_do",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1fc4837b-9270-4fc8-b563-2fa5b57320b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping",
      "poi_address": "6640 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Supermarket providing meats, seafood and baked goods, plus a pharmacy and deli.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-0196-70bd-9930-eb121286f26a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-0196-70bd-9930-eb121286f26a",
        "storage_key": "property/6767906449166311/019fd91f-0196-70bd-9930-eb121286f26a.webp",
        "width": 1088,
        "height": 612
      },
      "poi_business_url": "https://local.acmemarkets.com/pa/philadelphia/6640-oxford-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9423545181693899993&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "40.0502918",
      "poi_longitude": "-75.0869798",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-725-9310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-b923-73fd-ae1a-37c7b3ecc13b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-b923-73fd-ae1a-37c7b3ecc13b",
        "storage_key": "property/6767906449166311/019d0265-b923-73fd-ae1a-37c7b3ecc13b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp0KqPcC2xokR2XS1J2oox4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_98ff6882-4281-4c7a-824d-48495fc59eca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "ShopRite of Oxford & Levick",
      "poi_type": "Shopping",
      "poi_address": "6301 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-1419-745c-a00a-7807ab371b06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-1419-745c-a00a-7807ab371b06",
        "storage_key": "property/6767906449166311/019fd91f-1419-745c-a00a-7807ab371b06.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=402",
      "poi_directions_map_url": "https://maps.google.com/?cid=14214276694573517942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-oxford--levick",
      "poi_latitude": "40.0440154",
      "poi_longitude": "-75.08837299999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-744-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-b923-73fd-ae1a-37c7b3ecc13b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-b923-73fd-ae1a-37c7b3ecc13b",
        "storage_key": "property/6767906449166311/019d0265-b923-73fd-ae1a-37c7b3ecc13b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1RIUa-y2xokRdgwr31dBQ8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b5e5a4a3-3c32-444c-84f0-fb28e3f697c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "7350 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-4d77-704c-94a8-4f77bd991af1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-4d77-704c-94a8-4f77bd991af1",
        "storage_key": "property/6767906449166311/019fd91f-4d77-704c-94a8-4f77bd991af1.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://locations.dollartree.com/pa/philadelphia/7350-oxford-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17490603320139466225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "40.0627715",
      "poi_longitude": "-75.0841447",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 484-470-6290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI4jLcAC3xokR8UUu7Awbu_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cb42db88-fd58-4b9e-9d85-44710e6d6075",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping",
      "poi_address": "7913-29 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-10e4-73c7-a845-3434e90dc781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-10e4-73c7-a845-3434e90dc781",
        "storage_key": "property/6767906449166311/019fd91f-10e4-73c7-a845-3434e90dc781.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/0276?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=4211459439076454232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "40.0748203",
      "poi_longitude": "-75.08437889999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-342-8285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba47-7583-8a37-d7eb2925e0d0",
        "storage_key": "property/6767906449166311/019d0265-ba47-7583-8a37-d7eb2925e0d0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi27m_EmxxokRWC8e7Asccjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_64b3e75b-071f-4401-a892-081c258dc007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping",
      "poi_address": "8101 Oxford Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-15a4-7629-878e-2d4033d9f5a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-15a4-7629-878e-2d4033d9f5a6",
        "storage_key": "property/6767906449166311/019fd91f-15a4-7629-878e-2d4033d9f5a6.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.7-eleven.com/locations/pa/philadelphia/8101-oxford-avenue-25469?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6384549785833029505&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "40.0787253",
      "poi_longitude": "-75.0864527",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-745-7810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-bfcf-7792-8ce5-fc2a43022dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-bfcf-7792-8ce5-fc2a43022dad",
        "storage_key": "property/6767906449166311/019d0265-bfcf-7792-8ce5-fc2a43022dad.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJiz4ykTexxokRgb9fEzR6mlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d5b82dc-f266-43d0-bab9-04bb5c6a5201",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "1301 Rhawn St, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-197c-7224-9acf-0879adbf4da7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-197c-7224-9acf-0879adbf4da7",
        "storage_key": "property/6767906449166311/019fd91f-197c-7224-9acf-0879adbf4da7.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/philadelphia-pa-pharmacies/1301-rhawn-st-philadelphia-pa-19111/storeid=780?WT.mc_id=LS_GOOGLE_RX_780",
      "poi_directions_map_url": "https://maps.google.com/?cid=12853897780681183958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.0687505",
      "poi_longitude": "-75.0667805",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-342-1445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c093-77e8-b167-4a9bc56e4ce3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c093-77e8-b167-4a9bc56e4ce3",
        "storage_key": "property/6767906449166311/019d0265-c093-77e8-b167-4a9bc56e4ce3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_w0yg1SxxokR1hKvvO03YrI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f09333c1-c386-44e5-99a2-109a79ba1927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Oxford Beverage Inc",
      "poi_type": "Shopping",
      "poi_address": "7517 Oxford Ave #27, Philadelphia, PA 19111, USA",
      "poi_short_description": "Spot featuring a vast assortment of craft beer and other beverages ranging from room-temp to fridge-cold.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-245d-7405-8f36-6ddc30752e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-245d-7405-8f36-6ddc30752e6a",
        "storage_key": "property/6767906449166311/019fd91f-245d-7405-8f36-6ddc30752e6a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5680088101768597227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxford-beverage-inc",
      "poi_latitude": "40.0663975",
      "poi_longitude": "-75.0835974",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-745-9944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0ck3hbW2xokR6w7Xvgi6004",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c7a7eba-17e5-439b-9311-6ea1178098fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping",
      "poi_address": "1495 Old York Rd, Abington, PA 19001, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-26c0-77e0-a83b-ac0a2d18dae9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-26c0-77e0-a83b-ac0a2d18dae9",
        "storage_key": "property/6767906449166311/019fd91f-26c0-77e0-a83b-ac0a2d18dae9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/abington-township/1256",
      "poi_directions_map_url": "https://maps.google.com/?cid=6775394401295328449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "40.1253",
      "poi_longitude": "-75.1156792",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-572-6977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUzspt0-wxokRweRgdk8JB14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b08e3980-0440-466e-a498-6ded1975e795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "FINE WINE & GOOD SPIRITS",
      "poi_type": "Shopping",
      "poi_address": "Melrose Shopping Center, 103 W Cheltenham Ave, Cheltenham, PA 19012, USA",
      "poi_short_description": "State-run chain offering a standard selection of wine & liquor, plus tasting events.",
      "poi_long_description": "State-run chain offering a standard selection of wine & liquor, plus tasting events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-29ab-766d-a391-339a2ee3a637.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-29ab-766d-a391-339a2ee3a637",
        "storage_key": "property/6767906449166311/019fd91f-29ab-766d-a391-339a2ee3a637.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://finewineandgoodspirits.com/store-4605",
      "poi_directions_map_url": "https://maps.google.com/?cid=15564373231815288408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fine-wine--good-spirits",
      "poi_latitude": "40.051239",
      "poi_longitude": "-75.11859299999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 484-438-6473",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY0M2zRm3xokRWObyof3C_9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_efb73359-28a0-495b-8e56-f418d0594805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "J. Hampton Moore School",
      "poi_type": "Education",
      "poi_address": "6900 Summerdale Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://moore.philasd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4075424615653906333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-hampton-moore-school",
      "poi_latitude": "40.0492029",
      "poi_longitude": "-75.0770009",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-400-3180",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC-3Akb22xokRnRfvbBjRjjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a6dc12bb-f993-48f0-9c63-721140dd8f92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Castor Gardens Middle School",
      "poi_type": "Education",
      "poi_address": "1800 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-348b-75c6-a27d-c72d0f84070b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-348b-75c6-a27d-c72d0f84070b",
        "storage_key": "property/6767906449166311/019fd91f-348b-75c6-a27d-c72d0f84070b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://castorgardens.philasd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2153365605523632942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "castor-gardens-middle-school",
      "poi_latitude": "40.0524046",
      "poi_longitude": "-75.0690085",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-400-3190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCcH5d6S2xokRLrPH9JtK4h0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01b2b0cb-f623-45ac-b176-25b53fb92dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Northeast High School",
      "poi_type": "Education",
      "poi_address": "1601 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-39e1-7582-acdf-16f61c8084ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-39e1-7582-acdf-16f61c8084ed",
        "storage_key": "property/6767906449166311/019fd91f-39e1-7582-acdf-16f61c8084ed.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://nehs.philasd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5019604786911735143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-high-school",
      "poi_latitude": "40.0556875",
      "poi_longitude": "-75.0711522",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-400-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4dniGaW2xokRZ225bPU3qUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_11fe9c28-af04-4831-b079-d7ee93c2343c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Saint Cecilias School",
      "poi_type": "Education",
      "poi_address": "525 Rhawn St, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://scsfoxchase.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3079837038997814538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-cecilias-school",
      "poi_latitude": "40.0769002",
      "poi_longitude": "-75.0804548",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-725-8588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN3Ruq0mxxokRCj2OI3jHvSo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2010b81a-4514-4ffe-99fa-93d4ef3b9942",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "CEDAR GROVE CHRISTIAN ACADEMY",
      "poi_type": "Education",
      "poi_address": "6445 Bingham St, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-3751-709c-82ab-8d2c93db141e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-3751-709c-82ab-8d2c93db141e",
        "storage_key": "property/6767906449166311/019fd91f-3751-709c-82ab-8d2c93db141e.webp",
        "width": 956,
        "height": 1280
      },
      "poi_business_url": "http://www.cgca.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5377246066203446799&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-grove-christian-academy",
      "poi_latitude": "40.0496228",
      "poi_longitude": "-75.0920034",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-725-3383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq6o6w-m2xokRD07src7Qn0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_733380ca-26d9-452d-8e50-ae430c84cdb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Gospel of Grace Christian School",
      "poi_type": "Education",
      "poi_address": "315 Central Ave, Cheltenham, PA 19012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ggchristianschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11243499998187479233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gospel-of-grace-christian-school",
      "poi_latitude": "40.062425",
      "poi_longitude": "-75.09295589999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-663-1601",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7TyaaZW2xokRweARgK3vCJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd7497a8-6f3b-498a-9c58-1caa8d33fa08",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Presentation BVM School",
      "poi_type": "Education",
      "poi_address": "105 Old Soldiers Rd, Cheltenham, PA 19012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.presentationbvmschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8707430086291845068&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "presentation-bvm-school",
      "poi_latitude": "40.0578012",
      "poi_longitude": "-75.093443",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 215-379-3798",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH-hR-sS2xokRzG_5j4cB13g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f6f1432d-57a5-4c3c-9799-cedbf050fb93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Salus University",
      "poi_type": "Education",
      "poi_address": "8360 Old York Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-52b0-7168-bdcf-556a4c0e46e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-52b0-7168-bdcf-556a4c0e46e6",
        "storage_key": "property/6767906449166311/019fd91f-52b0-7168-bdcf-556a4c0e46e6.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.salus.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11598577888008244839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "salus-university",
      "poi_latitude": "40.0863723",
      "poi_longitude": "-75.1291063",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-780-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4a1QNMawxokRZ45uIiNt9qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_be7b38ec-d382-4aef-977e-5068ae45e41e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "La Salle University",
      "poi_type": "Education",
      "poi_address": "1900 W Olney Ave, Philadelphia, PA 19141, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-7045-76d8-b5be-7fa092412d22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-7045-76d8-b5be-7fa092412d22",
        "storage_key": "property/6767906449166311/019fd91f-7045-76d8-b5be-7fa092412d22.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.lasalle.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14108922838410391986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-salle-university",
      "poi_latitude": "40.0390398",
      "poi_longitude": "-75.1558184",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 215-951-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi-rtryq4xokRsvHYupH2zMM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8652527f-6f29-48e7-980b-8eae72f7bab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Community College of Philadelphia - Northwest Regional Center",
      "poi_type": "Education",
      "poi_address": "1300 W Godfrey Ave, Philadelphia, PA 19141, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-45be-747d-bcab-1a390e8e8a03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-45be-747d-bcab-1a390e8e8a03",
        "storage_key": "property/6767906449166311/019fd91f-45be-747d-bcab-1a390e8e8a03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9367930821717243167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "community-college-of-philadelphia---northwest-regional-center",
      "poi_latitude": "40.0466458",
      "poi_longitude": "-75.1402179",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-751-8773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVWV1W-3xokRH7Xj7HKTAYI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a411354b-e100-499f-bb58-6af9c88986b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Keswick Theatre",
      "poi_type": "Entertainment",
      "poi_address": "291 N Keswick Ave, Glenside, PA 19038, USA",
      "poi_short_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_long_description": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-60a6-7153-ba2c-18d96c96d320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-60a6-7153-ba2c-18d96c96d320",
        "storage_key": "property/6767906449166311/019fd91f-60a6-7153-ba2c-18d96c96d320.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.keswicktheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15835453283059281234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keswick-theatre",
      "poi_latitude": "40.1063448",
      "poi_longitude": "-75.14718959999999",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-572-7650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0aLkPZuwxokRUq0KctzUwts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a35cedfd-6e5f-43f6-93c6-fdbd7ab283eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Hiway Theater",
      "poi_type": "Entertainment",
      "poi_address": "212 York Rd, Jenkintown, PA 19046, USA",
      "poi_short_description": "This single-screen cinema built in 1913 focuses on independent, art-house & foreign films.",
      "poi_long_description": "This single-screen cinema built in 1913 focuses on independent, art-house & foreign films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-5a53-73f8-82a2-812adc34014a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-5a53-73f8-82a2-812adc34014a",
        "storage_key": "property/6767906449166311/019fd91f-5a53-73f8-82a2-812adc34014a.webp",
        "width": 914,
        "height": 1280
      },
      "poi_business_url": "http://www.hiwaytheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12685701504232848994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiway-theater",
      "poi_latitude": "40.0947767",
      "poi_longitude": "-75.1254988",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 267-864-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c095-74ad-865c-36e74adce83b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c095-74ad-865c-36e74adce83b",
        "storage_key": "property/6767906449166311/019d0265-c095-74ad-865c-36e74adce83b.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRaW_8GwxokRYv5vbk6qDLA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ccd2ef89-e0f1-4414-9ba7-891068af9487",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Cheltenham Center For The Arts",
      "poi_type": "Entertainment",
      "poi_address": "439 Ashbourne Rd, Cheltenham, PA 19012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-6987-74ff-9d28-b471d2867969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-6987-74ff-9d28-b471d2867969",
        "storage_key": "property/6767906449166311/019fd91f-6987-74ff-9d28-b471d2867969.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cheltenhamarts.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9772546294195341614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheltenham-center-for-the-arts",
      "poi_latitude": "40.0619612",
      "poi_longitude": "-75.0990658",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 215-379-4660",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLQRffNC2xokRLsmS0BMPn4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b2ba4a3-7e8e-4aa8-b160-d6302980ebc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Curtis Arboretum",
      "poi_type": "Entertainment",
      "poi_address": "1250 Church Rd, Wyncote, PA 19095, USA",
      "poi_short_description": "This scenic property features 2 ponds, more than 50 tree species & a historic hall for events.",
      "poi_long_description": "This scenic property features 2 ponds, more than 50 tree species & a historic hall for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-65be-76f9-a403-d941415d8155.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-65be-76f9-a403-d941415d8155",
        "storage_key": "property/6767906449166311/019fd91f-65be-76f9-a403-d941415d8155.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cheltenhamtownship.org/pview.aspx?id=40797&catid=29",
      "poi_directions_map_url": "https://maps.google.com/?cid=259993408148992418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "curtis-arboretum",
      "poi_latitude": "40.0862556",
      "poi_longitude": "-75.1508214",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-884-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wniK6-wxokRovGpkKCumwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4e41dd4f-c562-4eca-bb1d-62ca8b5be799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Morris Arboretum & Gardens of the University of Pennsylvania",
      "poi_type": "Entertainment",
      "poi_address": "100 E Northwestern Ave, Philadelphia, PA 19118, USA",
      "poi_short_description": "Afternoon destination drawing nature-lovers with its collection of flora on a 19th-century estate.",
      "poi_long_description": "Afternoon destination drawing nature-lovers with its collection of flora on a 19th-century estate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-7ca1-70aa-b596-47bbb315f9e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-7ca1-70aa-b596-47bbb315f9e8",
        "storage_key": "property/6767906449166311/019fd91f-7ca1-70aa-b596-47bbb315f9e8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.morrisarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5323901066464865602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-arboretum--gardens-of-the-university-of-pennsylvania",
      "poi_latitude": "40.0881617",
      "poi_longitude": "-75.2219848",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 215-247-5777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0IUmt-7xokRQi32DdBL4kk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fa3bc042-b544-47c7-b1e0-935ab8e35014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Abington Art Center",
      "poi_type": "Entertainment",
      "poi_address": "515 Meetinghouse Rd, Jenkintown, PA 19046, USA",
      "poi_short_description": "Sculpture gardens and walking trails feature at this art center with events, classes, and a treehouse.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-71b0-738a-91f4-8eeb093e4926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-71b0-738a-91f4-8eeb093e4926",
        "storage_key": "property/6767906449166311/019fd91f-71b0-738a-91f4-8eeb093e4926.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "http://abingtonartcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17812701015340068863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abington-art-center",
      "poi_latitude": "40.09222889999999",
      "poi_longitude": "-75.117054",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-887-4882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1VPybt2wxokR_6-VnTJtM_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b0fd5d7-967b-4c3e-8822-6f81b7e7225f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Beth Sholom Synagogue",
      "poi_type": "Entertainment",
      "poi_address": "8231 Old York Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-755a-77d8-9d22-45d5e7bc7e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-755a-77d8-9d22-45d5e7bc7e24",
        "storage_key": "property/6767906449166311/019fd91f-755a-77d8-9d22-45d5e7bc7e24.webp",
        "width": 1280,
        "height": 1015
      },
      "poi_business_url": "http://www.bethsholomcongregation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17817784284976495778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beth-sholom-synagogue",
      "poi_latitude": "40.0822071",
      "poi_longitude": "-75.1264382",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-887-1342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a7-74de-a658-91f6fa697e10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a7-74de-a658-91f6fa697e10",
        "storage_key": "property/6767906449166311/019d0265-c6a7-74de-a658-91f6fa697e10.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJYUEzGcmwxokRoryPjmd8Rfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e60456c2-51d1-41c1-b670-3ff062a03174",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Richard Wall House Museum",
      "poi_type": "Entertainment",
      "poi_address": "1 Wall Park Dr, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-8c06-7695-80ee-9ae3c1e43885.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-8c06-7695-80ee-9ae3c1e43885",
        "storage_key": "property/6767906449166311/019fd91f-8c06-7695-80ee-9ae3c1e43885.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheltenhamtownship.org/pView.aspx?id=3593&catid=26",
      "poi_directions_map_url": "https://maps.google.com/?cid=15516162393874928513&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richard-wall-house-museum",
      "poi_latitude": "40.0785305",
      "poi_longitude": "-75.1285448",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-887-1000 ext. 227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a5-716a-a5e1-f262ed882122.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a5-716a-a5e1-f262ed882122",
        "storage_key": "property/6767906449166311/019d0265-c6a5-716a-a5e1-f262ed882122.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSs0mMuwxokRgZMwNH17VNc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d474f6f-001d-4b69-8864-2fe93ac607e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "High School Park",
      "poi_type": "Entertainment",
      "poi_address": "Montgomery Ave & High School Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "Peaceful park featuring walking paths, trails and a meadow, plus birds and plants.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-d3d6-7550-837c-c855b67bda22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-d3d6-7550-837c-c855b67bda22",
        "storage_key": "property/6767906449166311/019fd91f-d3d6-7550-837c-c855b67bda22.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.highschoolpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15101063827238926690&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "high-school-park",
      "poi_latitude": "40.0714215",
      "poi_longitude": "-75.12417839999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 215-782-8082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____kzO3xokRYrkTwYrBkdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ce28082-b90c-4f1a-bcf0-44f5b59a5d05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Glenside Memorial Hall",
      "poi_type": "Entertainment",
      "poi_address": "185 S Keswick Ave, Glenside, PA 19038, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-8e57-707e-9546-12b206aae32d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-8e57-707e-9546-12b206aae32d",
        "storage_key": "property/6767906449166311/019fd91f-8e57-707e-9546-12b206aae32d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.cheltenhamtownship.org/facilityView.aspx?fid=9",
      "poi_directions_map_url": "https://maps.google.com/?cid=10903390441585446715&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "glenside-memorial-hall",
      "poi_latitude": "40.0976526",
      "poi_longitude": "-75.1529549",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 215-885-2428",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNU7APKCwxokROw8XhtafUJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e49b6868-cbc9-4b6f-87ba-af1920f9e55f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Jeanes Campus – Temple University Hospital",
      "poi_type": "Health",
      "poi_address": "7600 Central Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-860c-7780-8d6e-c41cd8e5fe0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-860c-7780-8d6e-c41cd8e5fe0c",
        "storage_key": "property/6767906449166311/019fd91f-860c-7780-8d6e-c41cd8e5fe0c.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.templehealth.org/locations/jeanes-campus-tuh?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8765815735638160293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jeanes-campus--temple-university-hospital",
      "poi_latitude": "40.0706545",
      "poi_longitude": "-75.08800029999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-728-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a8-757a-bac2-52593df4f761",
        "storage_key": "property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJATFVIDWxxokRpfM94fdupnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3b67a42-7f42-4c0c-ac93-48539480895e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Fox Chase Cancer Center",
      "poi_type": "Health",
      "poi_address": "333 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-90df-77cd-8a1e-d34d7c039184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-90df-77cd-8a1e-d34d7c039184",
        "storage_key": "property/6767906449166311/019fd91f-90df-77cd-8a1e-d34d7c039184.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.foxchase.org/locations/fox-chase-cancer-center-main-campus?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022604342825767040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-chase-cancer-center",
      "poi_latitude": "40.0716762",
      "poi_longitude": "-75.0911897",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-369-2427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm78uWPi3xokRgNBqOoxxF4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f9414728-37c8-4ca8-96c6-2e8639684fd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "AFC Urgent Care Cheltenham",
      "poi_type": "Health",
      "poi_address": "2401 W Cheltenham Ave, Wyncote, PA 19095, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-9f6e-7181-a14f-3690d9ff9c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-9f6e-7181-a14f-3690d9ff9c03",
        "storage_key": "property/6767906449166311/019fd91f-9f6e-7181-a14f-3690d9ff9c03.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.afcurgentcare.com/cheltenham/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-cheltenham-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9899829782581301859&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-cheltenham",
      "poi_latitude": "40.07405079999999",
      "poi_longitude": "-75.15545639999999",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-935-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoUm_83C5xokRY1KXV7xCY4k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_09c01268-0de5-47a7-bb27-0c68351a791f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Temple ReadyCare",
      "poi_type": "Health",
      "poi_address": "261 Old York Rd #216, Jenkintown, PA 19046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-9698-7581-b8cc-80f016abd8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-9698-7581-b8cc-80f016abd8fd",
        "storage_key": "property/6767906449166311/019fd91f-9698-7581-b8cc-80f016abd8fd.webp",
        "width": 790,
        "height": 440
      },
      "poi_business_url": "https://www.templereadycare.com/locations-hours/jenkintown?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=2288187525647022800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "temple-readycare",
      "poi_latitude": "40.0903471",
      "poi_longitude": "-75.1244535",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-884-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn_2B48OwxokR0LqrZW5GwR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07a62ced-ddb1-4a10-b057-7cf35b27c2ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "1301 Rhawn St, Philadelphia, PA 19111, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-9e98-729a-9b6e-b323a3e1c8b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-9e98-729a-9b6e-b323a3e1c8b1",
        "storage_key": "property/6767906449166311/019fd91f-9e98-729a-9b6e-b323a3e1c8b1.webp",
        "width": 1005,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/philadelphia-pa-pharmacies/1301-rhawn-st-philadelphia-pa-19111/storeid=780?WT.mc_id=LS_GOOGLE_FS_780",
      "poi_directions_map_url": "https://maps.google.com/?cid=14546328218102625511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "40.0689852",
      "poi_longitude": "-75.0666815",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-342-1445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhzzTnFSxxokR53Q_0nHw3sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c55abbad-824a-4929-a18a-0a3f8cbdafac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "The Abington Club",
      "poi_type": "Health",
      "poi_address": "300 Meetinghouse Rd and, Sunset Ave, Jenkintown, PA 19046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-9e9f-7696-9b70-ca3366d2aa3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-9e9f-7696-9b70-ca3366d2aa3a",
        "storage_key": "property/6767906449166311/019fd91f-9e9f-7696-9b70-ca3366d2aa3a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.abingtonclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8139599235397895489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-abington-club",
      "poi_latitude": "40.0895376",
      "poi_longitude": "-75.123069",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-885-0734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbS5CgsOwxokRQcXuD2Gq9XA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4cc15668-c77f-4afe-9071-8bf8d4f74927",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Fit for Life Jenkintown",
      "poi_type": "Health",
      "poi_address": "714 West Ave, Jenkintown, PA 19046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-bdcb-7039-995b-f76add69e405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-bdcb-7039-995b-f76add69e405",
        "storage_key": "property/6767906449166311/019fd91f-bdcb-7039-995b-f76add69e405.webp",
        "width": 1081,
        "height": 1280
      },
      "poi_business_url": "https://fitforlifejenkintown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10091976918578211765&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-for-life-jenkintown",
      "poi_latitude": "40.0958766",
      "poi_longitude": "-75.1266179",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-887-2098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL0_oIVKxxokRtatLsYnnDYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_565623d5-6d85-43e1-b150-932728a690e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Center for Spiritual Well-being",
      "poi_type": "Health",
      "poi_address": "8231 Old York Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-a701-7686-8e8d-320764e06371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-a701-7686-8e8d-320764e06371",
        "storage_key": "property/6767906449166311/019fd91f-a701-7686-8e8d-320764e06371.webp",
        "width": 853,
        "height": 315
      },
      "poi_business_url": "http://www.spiritualwell-being.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1863507998842033911&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "center-for-spiritual-well-being",
      "poi_latitude": "40.0822071",
      "poi_longitude": "-75.1264382",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-887-1342 ext. 109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4aHUJsmwxokR9xYU06aC3Bk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e9f774af-3a78-4dea-a061-058cdbcd4066",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Violets In Bloom",
      "poi_type": "Health",
      "poi_address": "7906 High School Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-a842-7654-8a5b-b768762ca75f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-a842-7654-8a5b-b768762ca75f",
        "storage_key": "property/6767906449166311/019fd91f-a842-7654-8a5b-b768762ca75f.webp",
        "width": 1100,
        "height": 733
      },
      "poi_business_url": "http://myvioletsinbloom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16038897551497351421&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "violets-in-bloom",
      "poi_latitude": "40.0717",
      "poi_longitude": "-75.12687439999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSUf3pES3xokR_dDhaVicld4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8bca59e8-c24a-4ad8-bc32-5cd022e4ccc7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Einstein Medical Center Elkins Park",
      "poi_type": "Health",
      "poi_address": "60 Township Line Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.einstein.edu/einstein-medical-center-elkins-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10518562957727736915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-medical-center-elkins-park",
      "poi_latitude": "40.07311079999999",
      "poi_longitude": "-75.1051073",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-663-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a8-757a-bac2-52593df4f761",
        "storage_key": "property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5_L8CqxxokRU6Txwkdx-ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8109343b-a34f-4d82-b946-5e565ed18371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Jardel Recreation Center",
      "poi_type": "Outdoor Attractions",
      "poi_address": "1400 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "Gym and soccer field as well as a pool with an 8-foot diving area and a playground, along with hockey rinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-c238-724a-87bc-981afe3d956a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-c238-724a-87bc-981afe3d956a",
        "storage_key": "property/6767906449166311/019fd91f-c238-724a-87bc-981afe3d956a.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/jardelreccenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12979622970581828315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jardel-recreation-center",
      "poi_latitude": "40.0562527",
      "poi_longitude": "-75.07539179999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-685-0596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ38ov8Lq2xokR28IHoFLiILQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb7d6bd4-929d-4215-8add-cb74e4e60455",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Lawncrest Recreation Center",
      "poi_type": "Outdoor Attractions",
      "poi_address": "6000 Rising Sun Avenue, E Comly St, Philadelphia, PA 19111, USA",
      "poi_short_description": "Community recreation center with a basketball court and offerings for adults and kids.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-c7af-725f-851b-b854723736da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-c7af-725f-851b-b854723736da",
        "storage_key": "property/6767906449166311/019fd91f-c7af-725f-851b-b854723736da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://crestls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17128436477443709827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lawncrest-recreation-center",
      "poi_latitude": "40.0454474",
      "poi_longitude": "-75.1008804",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2U0Jqea2xokRgxvg0zlutO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ab9706df-f0e8-45a0-b43f-07d4e687ebd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Burholme Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "401 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "85-acre park with wooded areas & spaces for baseball, football & soccer, plus a driving range.",
      "poi_long_description": "85-acre park with wooded areas & spaces for baseball, football & soccer, plus a driving range.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-d5eb-7198-a5ab-5e76c1f9700d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-d5eb-7198-a5ab-5e76c1f9700d",
        "storage_key": "property/6767906449166311/019fd91f-d5eb-7198-a5ab-5e76c1f9700d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.phila.gov/parksandrecreation/findafacility/findrecreationarea.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=14113561717546550586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "burholme-park",
      "poi_latitude": "40.0671482",
      "poi_longitude": "-75.089962",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 215-685-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJa8W67cy2xokROgXq8Zpx3cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6ab84da0-f6a6-4558-bdcd-266ec3d72d6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Fox Chase Farm",
      "poi_type": "Outdoor Attractions",
      "poi_address": "8500 Pine Rd, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-dcd4-75d8-9ff9-86124e1a30f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-dcd4-75d8-9ff9-86124e1a30f6",
        "storage_key": "property/6767906449166311/019fd91f-dcd4-75d8-9ff9-86124e1a30f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.philasd.org/foxchasefarm/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13284955895617668789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-chase-farm",
      "poi_latitude": "40.08885799999999",
      "poi_longitude": "-75.07211199999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-400-3310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmZm29WixxokRtcYFFwClXbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_38decb7f-9d20-4736-a26a-2dcb94bfc414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Pennypack Environmental Center",
      "poi_type": "Outdoor Attractions",
      "poi_address": "8600A Verree Rd, Philadelphia, PA 19115, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-e56a-723e-a55f-caf7827d9734.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-e56a-723e-a55f-caf7827d9734",
        "storage_key": "property/6767906449166311/019fd91f-e56a-723e-a55f-caf7827d9734.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://linktr.ee/explore_pec",
      "poi_directions_map_url": "https://maps.google.com/?cid=10024485081916866614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennypack-environmental-center",
      "poi_latitude": "40.0876664",
      "poi_longitude": "-75.05951759999999",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 215-685-0470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJH77jMlmzxokRNoDb6xEgHos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_daa76c89-bd29-4cea-89d5-606f05abeb63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Pennypack Pavilion",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Pine Rd, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-2a23-70cf-817c-37055897bef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-2a23-70cf-817c-37055897bef8",
        "storage_key": "property/6767906449166311/019fd920-2a23-70cf-817c-37055897bef8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/PPRSpecialEventsOffice/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2106793382149302181&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennypack-pavilion",
      "poi_latitude": "40.0885281",
      "poi_longitude": "-75.06758409999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-685-0060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRwoSGexxokRpScnNmvVPB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_97ac84b8-79d5-4187-99b4-09bb7743ef5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Tacony Creek Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "Philadelphia, PA 19120, USA",
      "poi_short_description": "On 302 acres, this narrow preserve offers creek views plus native trees & wildflowers.",
      "poi_long_description": "On 302 acres, this narrow preserve offers creek views plus native trees & wildflowers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-df51-74c9-b993-8701c67fb420.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-df51-74c9-b993-8701c67fb420",
        "storage_key": "property/6767906449166311/019fd91f-df51-74c9-b993-8701c67fb420.webp",
        "width": 660,
        "height": 440
      },
      "poi_business_url": "http://taconycreekpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17875768090777071384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacony-creek-park",
      "poi_latitude": "40.0335999",
      "poi_longitude": "-75.1129816",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ91aSfKq3xokRGK8HYl58E_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bff26bc9-0d3d-4d2e-b1ed-3336312b7cd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Lorimer Park",
      "poi_type": "Outdoor Attractions",
      "poi_address": "183 Moredon Rd, Huntingdon Valley, PA 19006, USA",
      "poi_short_description": "Meadows, woods & a scenic creek attract horseback riders, birders, hikers & other nature lovers.",
      "poi_long_description": "Meadows, woods & a scenic creek attract horseback riders, birders, hikers & other nature lovers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-febb-759c-8fbf-56d6e1ac3c56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-febb-759c-8fbf-56d6e1ac3c56",
        "storage_key": "property/6767906449166311/019fd91f-febb-759c-8fbf-56d6e1ac3c56.webp",
        "width": 1095,
        "height": 1280
      },
      "poi_business_url": "https://www.montcopa.org/872/Lorimer-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=354651384762853688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lorimer-park",
      "poi_latitude": "40.0969929",
      "poi_longitude": "-75.0736507",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 215-947-3477",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c5e6-706d-b257-c03c3eb8c64f",
        "storage_key": "property/6767906449166311/019d0265-c5e6-706d-b257-c03c3eb8c64f.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJO4_tSHCxxokROOnjL4756wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_26263790-c226-427d-a262-ea5fbcf0d679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Houseman Playground",
      "poi_type": "Outdoor Attractions",
      "poi_address": "5091 Summerdale Ave, Philadelphia, PA 19124, USA",
      "poi_short_description": "Popular place for kids featuring a pool, 2 basketball courts and a free-admission playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-f935-721d-a9e0-7530237e6955.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-f935-721d-a9e0-7530237e6955",
        "storage_key": "property/6767906449166311/019fd91f-f935-721d-a9e0-7530237e6955.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2157043749999001537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houseman-playground",
      "poi_latitude": "40.0302543",
      "poi_longitude": "-75.0930557",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 215-685-1240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyUgbYVi2xokRwb-qs9xb7x0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3af38a29-5968-4120-a3f3-611ddca9413d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Cheltenham",
      "poi_type": "Transit",
      "poi_address": "Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-f0ca-730d-8d95-2e3e8d6c07a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-f0ca-730d-8d95-2e3e8d6c07a3",
        "storage_key": "property/6767906449166311/019fd91f-f0ca-730d-8d95-2e3e8d6c07a3.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "http://www.septa.org/stations/rail/cheltenham.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6058086550758749707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheltenham",
      "poi_latitude": "40.0579328",
      "poi_longitude": "-75.0929342",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJObT0rMW2xokRC_aL7J6lElQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_33a9bce7-2d1b-45d9-bdcb-5ae3a2b19530",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Lawndale",
      "poi_type": "Transit",
      "poi_address": "Cheltenham Township, PA 19012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-09f6-73dc-bdd4-7122e832359e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-09f6-73dc-bdd4-7122e832359e",
        "storage_key": "property/6767906449166311/019fd920-09f6-73dc-bdd4-7122e832359e.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.septa.org/stations/rail/lawndale.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=8974733786402263877&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lawndale",
      "poi_latitude": "40.0513664",
      "poi_longitude": "-75.1033923",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJh54FpOC2xokRRRM0HNSojHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4140a1a5-9462-4efc-a414-a7e05de25e2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Ryers",
      "poi_type": "Transit",
      "poi_address": "Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-1073-73cc-8d75-bdc3ace0b23d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-1073-73cc-8d75-bdc3ace0b23d",
        "storage_key": "property/6767906449166311/019fd920-1073-73cc-8d75-bdc3ace0b23d.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.septa.org/stations/rail/ryers.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=17447512665111332838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ryers",
      "poi_latitude": "40.0637431",
      "poi_longitude": "-75.086744",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVqNjsm2xokR5gcX-lMEIvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8e645bf0-d43d-4836-af69-bffd1e141d98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Fox Chase",
      "poi_type": "Transit",
      "poi_address": "440 Rhawn St, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-1584-726f-9734-e935d147e85a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-1584-726f-9734-e935d147e85a",
        "storage_key": "property/6767906449166311/019fd920-1584-726f-9734-e935d147e85a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/foxchase.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10749959342800068220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-chase",
      "poi_latitude": "40.0759494",
      "poi_longitude": "-75.0835732",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTBvx0mxxokRfF59CRGHL5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73c3f73a-a560-486e-9357-cc8974572410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Elkins Park",
      "poi_type": "Transit",
      "poi_address": "7876 Spring Ave, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-27cb-702d-b5e0-3f01ade71478.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-27cb-702d-b5e0-3f01ade71478",
        "storage_key": "property/6767906449166311/019fd920-27cb-702d-b5e0-3f01ade71478.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.septa.org/stations/rail/elkinspark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13935730140067096992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elkins-park",
      "poi_latitude": "40.0712238",
      "poi_longitude": "-75.1278805",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-580-6887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9-6STS3xokRoGlnTLqoZcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fa56acb5-d9c0-44e6-8a73-5770196d95c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Melrose Park",
      "poi_type": "Transit",
      "poi_address": "900 Valley Rd, Melrose Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-277f-729c-a3a4-9dc419a3dbe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-277f-729c-a3a4-9dc419a3dbe7",
        "storage_key": "property/6767906449166311/019fd920-277f-729c-a3a4-9dc419a3dbe7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.septa.org/stations/rail/melrosepark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=10751196527427971087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "melrose-park",
      "poi_latitude": "40.0595273",
      "poi_longitude": "-75.1292544",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 215-580-6891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv4_2Oj-3xokRD-jBh0fsM5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bbef30f8-215d-4e79-8042-1e7cceb08d0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Jenkintown-Wyncote",
      "poi_type": "Transit",
      "poi_address": "2 Greenwood Ave, Jenkintown, PA 19046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-2b81-76b0-9779-095afa8e4d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-2b81-76b0-9779-095afa8e4d4f",
        "storage_key": "property/6767906449166311/019fd920-2b81-76b0-9779-095afa8e4d4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.septa.org/stations/rail/jenkintown.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769100648293665955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jenkintown-wyncote",
      "poi_latitude": "40.0931443",
      "poi_longitude": "-75.137964",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 215-580-6838",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cbf6-735f-8158-bfa09f05e052",
        "storage_key": "property/6767906449166311/019d0265-cbf6-735f-8158-bfa09f05e052.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3xu0I7ywxokRowwFP3n2D1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42369896-af53-491f-a503-41aed1319218",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Olney Av & Broad St",
      "poi_type": "Transit",
      "poi_address": "Philadelphia, PA 19141, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-36a3-75cd-b756-592b9f58b6f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-36a3-75cd-b756-592b9f58b6f6",
        "storage_key": "property/6767906449166311/019fd920-36a3-75cd-b756-592b9f58b6f6.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=9973590673800203735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olney-av--broad-st",
      "poi_latitude": "40.03902799999999",
      "poi_longitude": "-75.144958",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHYeuWni3xokR140CH-BPaYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a56c7c8d-93b1-4253-ae52-8509633c420f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Martins Mill Rd & Gilham St",
      "poi_type": "Transit",
      "poi_address": "Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=971095404912163388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martins-mill-rd--gilham-st",
      "poi_latitude": "40.050339",
      "poi_longitude": "-75.091499",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA54QCsK2xokRPLrNLCAGeg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8a5772c5-0e2c-442a-a095-f3aee7dfabf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Roosevelt Blvd & Cottman Av",
      "poi_type": "Transit",
      "poi_address": "Philadelphia, PA 19149, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-438e-720c-9385-8e026d5bad93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-438e-720c-9385-8e026d5bad93",
        "storage_key": "property/6767906449166311/019fd920-438e-720c-9385-8e026d5bad93.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8102188181607736191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosevelt-blvd--cottman-av",
      "poi_latitude": "40.04508999999999",
      "poi_longitude": "-75.05429",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbHtGiK0xokRf-MYVDnBcHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_55ad86d2-e23f-476f-aca9-bb2a7028bb64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Einstein Medical Center Elkins Park",
      "poi_type": "Major Employers",
      "poi_address": "60 Township Line Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.einstein.edu/einstein-medical-center-elkins-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10518562957727736915&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "einstein-medical-center-elkins-park",
      "poi_latitude": "40.07311079999999",
      "poi_longitude": "-75.1051073",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-663-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a8-757a-bac2-52593df4f761",
        "storage_key": "property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5_L8CqxxokRU6Txwkdx-ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5036b042-40cd-42ec-a430-c3dee135b412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Arcadia University",
      "poi_type": "Major Employers",
      "poi_address": "450 S Easton Rd, Glenside, PA 19038, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-437b-71d1-a729-c9ce97400897.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-437b-71d1-a729-c9ce97400897",
        "storage_key": "property/6767906449166311/019fd920-437b-71d1-a729-c9ce97400897.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arcadia.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13464473212921485442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arcadia-university",
      "poi_latitude": "40.0920362",
      "poi_longitude": "-75.16594309999999",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-572-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsUxWxA-6xokRgpjynwxr27o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c8299bc3-a31c-4a5b-96e7-62d51e83b156",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Penn State Abington",
      "poi_type": "Major Employers",
      "poi_address": "1600 Woodland Rd, Abington, PA 19001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-3667-707a-9d20-916f7ee10274.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-3667-707a-9d20-916f7ee10274",
        "storage_key": "property/6767906449166311/019fd920-3667-707a-9d20-916f7ee10274.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://abington.psu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15986706420555776471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "penn-state-abington",
      "poi_latitude": "40.1152602",
      "poi_longitude": "-75.1107289",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-881-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZwyIqlWwxokR1wGvzckw3N0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_28db023a-1490-468c-a960-3f7c6fcc0962",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Abington Hospital - Jefferson Health",
      "poi_type": "Major Employers",
      "poi_address": "1200 Old York Rd, Abington, PA 19001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-4e53-7418-9e39-cf79a47160dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-4e53-7418-9e39-cf79a47160dc",
        "storage_key": "property/6767906449166311/019fd920-4e53-7418-9e39-cf79a47160dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.abingtonradiology.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11692431881747218379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abington-hospital---jefferson-health",
      "poi_latitude": "40.120329",
      "poi_longitude": "-75.1196381",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 215-481-3926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYxqPklCwxokRy7_-59jcQ6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f4f9e3a-e13d-4846-84ae-7e9fa930b6b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Fox Chase Cancer Center",
      "poi_type": "Major Employers",
      "poi_address": "333 Cottman Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-90df-77cd-8a1e-d34d7c039184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-90df-77cd-8a1e-d34d7c039184",
        "storage_key": "property/6767906449166311/019fd91f-90df-77cd-8a1e-d34d7c039184.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.foxchase.org/locations/fox-chase-cancer-center-main-campus?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=10022604342825767040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fox-chase-cancer-center",
      "poi_latitude": "40.0716762",
      "poi_longitude": "-75.0911897",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-369-2427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-66ba27dbfc28",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-66ba27dbfc28.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm78uWPi3xokRgNBqOoxxF4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_59bb9afb-c7e5-4467-bc83-1d74ad1c645f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Jeanes Campus – Temple University Hospital",
      "poi_type": "Major Employers",
      "poi_address": "7600 Central Ave, Philadelphia, PA 19111, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd91f-860c-7780-8d6e-c41cd8e5fe0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd91f-860c-7780-8d6e-c41cd8e5fe0c",
        "storage_key": "property/6767906449166311/019fd91f-860c-7780-8d6e-c41cd8e5fe0c.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://www.templehealth.org/locations/jeanes-campus-tuh?utm_source=google&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8765815735638160293&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jeanes-campus--temple-university-hospital",
      "poi_latitude": "40.0706545",
      "poi_longitude": "-75.08800029999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 215-728-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a8-757a-bac2-52593df4f761",
        "storage_key": "property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJATFVIDWxxokRpfM94fdupnk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cf727373-4d15-4161-bffd-dc37f2f4f271",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Holy Redeemer Hospital",
      "poi_type": "Major Employers",
      "poi_address": "1648 Huntingdon Pike, Meadowbrook, PA 19046, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-497a-77b1-9d5d-6a6ef6ccd5bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-497a-77b1-9d5d-6a6ef6ccd5bb",
        "storage_key": "property/6767906449166311/019fd920-497a-77b1-9d5d-6a6ef6ccd5bb.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.redeemerhealth.org/hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=11923753665211167478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holy-redeemer-hospital",
      "poi_latitude": "40.109621",
      "poi_longitude": "-75.0824198",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 215-947-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c6a8-757a-bac2-52593df4f761",
        "storage_key": "property/6767906449166311/019d0265-c6a8-757a-bac2-52593df4f761.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2fBsRexxokR9nIspMiueaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0d0f77ad-599e-41cc-81c2-41735d6bd14c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Cheltenham Township",
      "poi_type": "Major Employers",
      "poi_address": "8230 Old York Rd, Elkins Park, PA 19027, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-5bde-71ff-addf-aa0ca02f01e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-5bde-71ff-addf-aa0ca02f01e7",
        "storage_key": "property/6767906449166311/019fd920-5bde-71ff-addf-aa0ca02f01e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cheltenhamtownship.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11895501523661643162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheltenham-township",
      "poi_latitude": "40.0815544",
      "poi_longitude": "-75.1275024",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 215-887-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ccf9-7068-b3c1-f87cacbcb9d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ccf9-7068-b3c1-f87cacbcb9d8",
        "storage_key": "property/6767906449166311/019d0265-ccf9-7068-b3c1-f87cacbcb9d8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd_bvG8mwxokRml34VpxPFaU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_99ebb104-4cdb-408e-9d5b-2e4da4306f0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Willow Grove Park",
      "poi_type": "Major Employers",
      "poi_address": "2500 W Moreland Rd, Willow Grove, PA 19090, USA",
      "poi_short_description": "More than 130 retailers in a 3-story shopping mall with Victorian-era inspired decor & a carousel.",
      "poi_long_description": "More than 130 retailers in a 3-story shopping mall with Victorian-era inspired decor & a carousel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019fd920-4da4-75ba-88b2-470ce61f797b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd920-4da4-75ba-88b2-470ce61f797b",
        "storage_key": "property/6767906449166311/019fd920-4da4-75ba-88b2-470ce61f797b.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "https://willowgroveparkmall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7320160412435769219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willow-grove-park",
      "poi_latitude": "40.1401974",
      "poi_longitude": "-75.1236988",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 215-657-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-ba9f-706f-a71c-633b52787486",
        "storage_key": "property/6767906449166311/019d0265-ba9f-706f-a71c-633b52787486.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfxx3xTuwxokRg2ccehxvlmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_73a5be11-dc64-4c9d-83e4-e6cfdfe2f120",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "poi_name": "Abington School District",
      "poi_type": "Major Employers",
      "poi_address": "970 Highland Ave, Abington, PA 19001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.abington.k12.pa.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1897824047076959383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abington-school-district",
      "poi_latitude": "40.1130005",
      "poi_longitude": "-75.1290088",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 215-884-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-c0d3-7734-8d35-3a1b6c228835",
        "storage_key": "property/6767906449166311/019d0265-c0d3-7734-8d35-3a1b6c228835.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdU4gC1-wxokRl2Q3bOpsVho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_4a7218c9-cc91-450d-96a2-63b9e51a7c07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5e52c95b-2769-4ea7-9739-ddd119aac705",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_8844df4a-405d-4d06-ad17-088e746c00c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a14f4158-9e75-4162-9356-29dafb9b53e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0d478c73-9568-4036-9130-e6c0318e4505",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_bd85699d-a898-4b83-aac0-63d3746ba454",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2711-fb6f-74be-a273-c53c3420e213",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-cheltenham-station-apartments-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311"
    },
    {
      "lead_collector_id": "019c3043-3b76-720c-9694-9f6c96387e69",
      "lead_source": "FACEBOOK_ADS",
      "name": "cheltenham-station",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311"
    },
    {
      "lead_collector_id": "019c3043-3be8-7591-8f1b-786547a6c26d",
      "lead_source": "LANDING_PAGE",
      "name": "cheltenham-station",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-northeast-philadelphia-487",
      "search_query": "pet friendly apartments northeast philadelphia",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Northeast Philadelphia",
      "h2_subtitle": "Explore our pet friendly apartments in Northeast Philadelphia. Enjoy a welcoming community with all the comforts of home for you and your furry friend.",
      "page_copy": "At Cheltenham Station Apartments in Northeast Philadelphia, we know how important it is to find a home that welcomes every member of your family, including the furry ones. Our pet-friendly apartments are thoughtfully designed to accommodate pets without compromising on style or comfort. Whether you opt for a cozy studio or a spacious two-bedroom unit, you'll find modern amenities like air conditioning, upgraded kitchens, and the joy of pet-friendly spaces. \n\nOur vibrant community in Northeast Philadelphia offers more than just a home; it provides a lifestyle. With ample outdoor areas for strolls and nearby parks, your pets will love living here as much as you do. To keep things convenient, we provide flexible rent payment options and short-term leases. Cheltenham Station Apartments isn't just a place to live; it's a place you and your pets will love to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Northeast Philadelphia",
      "seo_description": "Discover pet friendly apartments in Northeast Philadelphia at Cheltenham Station, where comfort and a welcoming community await you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "air-conditioned-apartments-philadelphia-county-37",
      "search_query": "air conditioned apartments in philadelphia county",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Philadelphia County",
      "h2_subtitle": "Discover comfort at Cheltenham Station Apartments with air conditioned living spaces. Our Philadelphia County community offers modern amenities and cozy homes.",
      "page_copy": "Experience the convenience of air conditioned living at Cheltenham Station Apartments. Located in the heart of Philadelphia County, our apartments are designed with your comfort in mind. Choose from our selection of beautifully renovated studio, one-bedroom, or two-bedroom homes, all featuring efficient air conditioning systems that keep you cool during the hot Philadelphia summers.\n\nCheltenham Station Apartments go beyond just air conditioning. Our community boasts a range of modern amenities, including upgraded kitchens, pet-friendly options, and flexible rent payments. Nestled in vibrant Northeast Philadelphia, residents enjoy a thriving community atmosphere and various resident activities. With short-term leases available, you can find the perfect home that fits your lifestyle needs. Live comfortably and conveniently at Cheltenham Station Apartments, where air conditioning is just one of the many perks of resident life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Philadelphia County",
      "seo_description": "Find air conditioned apartments in Philadelphia County at Cheltenham Station. Enjoy modern amenities and a cool, comfortable home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-upgraded-kitchens-19111-65",
      "search_query": "apartments with upgraded kitchens in 19111",
      "category": "Amenity",
      "h1_title": "Apartments with Upgraded Kitchens in 19111",
      "h2_subtitle": "Find stylish living at Cheltenham Station Apartments with upgraded kitchens. Our Philadelphia apartments in 19111 offer modern amenities and more.",
      "page_copy": "At Cheltenham Station Apartments, located in the bustling 19111 ZIP code, enjoy the luxury of upgraded kitchens that cater to all your culinary needs. Our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans include modern appliances, sleek finishes, and ample storage space, making meal preparation a breeze. Experience the blend of style and functionality in each kitchen, designed to make you feel right at home.\n\nBeyond the upgraded kitchens, residents of Cheltenham Station benefit from a host of amenities including air conditioning, pet-friendly policies, and flexible rent payment options. Set in Northeast Philadelphia, our community is vibrant and welcoming, with activities and conveniences that make everyday living enjoyable. Whether you're seeking short-term leases or a long-term residence, Cheltenham Station Apartments in the 19111 area is the ideal place to call home, providing both comfort and modern amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Upgraded Kitchens in 19111",
      "seo_description": "Explore apartments with upgraded kitchens in 19111 at Cheltenham Station. Enjoy modern amenities and stylish living spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "24-hour-maintenance-apartments-northeast-philly-222",
      "search_query": "24-hour maintenance apartments in northeast philly",
      "category": "Amenity",
      "h1_title": "24-Hour Maintenance Apartments in Northeast Philly",
      "h2_subtitle": "Cheltenham Station offers 24-hour maintenance apartments in Northeast Philly. Enjoy peace of mind with uninterrupted support in a vibrant community.",
      "page_copy": "Cheltenham Station Apartments, located in Northeast Philly, is dedicated to providing residents with peace of mind through our reliable 24-hour emergency maintenance services. Our commitment to your comfort means that no matter what time of day it is, help is just a call away. Choose from our variety of floor plans including studios, one-bedroom, and two-bedroom options, each designed with comfort and convenience in mind.\n\nEnjoy the perks of living in a community that prioritizes your needs. Beyond our round-the-clock maintenance, Cheltenham Station features amenities like air-conditioned units, upgraded kitchens, and pet-friendly policies. Situated in the lively Northeast Philadelphia area, residents are part of a vibrant community with regular activities and convenient living options such as flexible rent payments and short-term leases. Experience hassle-free living where maintenance is never a worry at Cheltenham Station Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "24-Hour Maintenance Apartments in Northeast Philly",
      "seo_description": "Discover 24-hour maintenance apartments in Northeast Philly at Cheltenham Station. Enjoy continuous support and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "philly-apartments-resident-activities-543",
      "search_query": "philly apartments with resident activities",
      "category": "Amenity",
      "h1_title": "Philly Apartments with Resident Activities",
      "h2_subtitle": "Enjoy an engaging lifestyle at Cheltenham Station Apartments in Philly. Join a community offering resident activities and modern living features.",
      "page_copy": "Cheltenham Station Apartments in Philadelphia offers a vibrant community atmosphere, enriched with diverse resident activities that foster connection and enjoyment. Join fellow residents in social events, fun gatherings, and recreational activities that are planned regularly, creating a sense of belonging and community spirit. Our apartments, available in studio, one-bedroom, and two-bedroom layouts, provide not only a place to live, but a vibrant community to call home.\n\nIn addition to engaging resident activities, Cheltenham Station Apartments ensure a comfortable living experience with amenities like upgraded kitchens, air conditioning, and pet-friendly options. Ideally located in Northeast Philly, our community offers more than just living spaces – it's a lifestyle. With flexible rent payment options and short-term leases available, residents enjoy modern convenience coupled with an active, engaging community life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Philly Apartments with Resident Activities",
      "seo_description": "Discover Philly apartments with resident activities at Cheltenham Station. Enjoy a lively community life with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-northeast-philadelphia-330",
      "search_query": "1 bedroom apartments northeast philadelphia",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Northeast Philadelphia",
      "h2_subtitle": "Explore spacious 1 bedroom apartments at Cheltenham Station in Northeast Philadelphia. Modern amenities and a vibrant community await you.",
      "page_copy": "Cheltenham Station Apartments offers ideal one-bedroom living options in Northeast Philadelphia, perfect for those seeking modern comfort and convenience. Our 1 bedroom apartments feature open floor plans, upgraded kitchens, and ample storage, providing a cozy and inviting space that fits your lifestyle needs. Whether you're moving in alone or as a couple, you'll find these residences perfectly suited to your living style.\n\nSituated in the lively Northeast Philly area, Cheltenham Station not only offers impressive living spaces but also enhances the residential experience with amenities like 24-hour emergency maintenance, pet-friendly accommodations, and flexible rent payment options. Engage with a vibrant community through resident activities and enjoy living in an area that blends convenience and charm, making every moment at Cheltenham Station Apartments both comfortable and exciting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Northeast Philadelphia",
      "seo_description": "Find your perfect 1 bedroom apartment in Northeast Philadelphia at Cheltenham Station, featuring modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-philadelphia-county-41",
      "search_query": "2 bedroom apartments philadelphia county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Philadelphia County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Cheltenham Station in Philadelphia County. Experience modern living with exceptional amenities.",
      "page_copy": "Cheltenham Station Apartments is your destination for spacious and modern 2 bedroom apartments in Philadelphia County. Perfect for families, roommates, or those who simply desire extra space, our two-bedroom units are designed with style and functionality in mind. Featuring upgraded kitchens, air conditioning, and an open layout, these homes provide the perfect setting for comfortable, modern living.\n\nLocated in the heart of Philadelphia County, Cheltenham Station Apartments offers more than just a place to live. Residents enjoy the benefits of a vibrant community with engaging resident activities, pet-friendly policies, and flexible rent payment plans. With our 24-hour emergency maintenance service, you can rest easy knowing help is always available. Make Cheltenham Station your home and experience the best of apartment living in a thriving community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Philadelphia County",
      "seo_description": "Explore 2 bedroom apartments in Philadelphia County at Cheltenham Station. Enjoy modern amenities and a lively community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "studio-apartments-near-19111-327",
      "search_query": "studio apartments near 19111",
      "category": "Floorplan",
      "h1_title": "Studio Apartments Near 19111",
      "h2_subtitle": "Discover modern studio apartments near the 19111 area at Cheltenham Station. Experience convenience and style in Northeast Philadelphia.",
      "page_copy": "Cheltenham Station Apartments offers ideal studio apartments conveniently located near the 19111 area, perfect for anyone seeking efficiency without sacrificing style. These studio units feature modern layouts with upgraded kitchens and ample living space, providing a comfortable environment tailored to suit your lifestyle. Enjoy the simplicity and ease of studio living while benefitting from a community that values comfort and connection.\n\nLocated in vibrant Northeast Philadelphia, Cheltenham Station ensures residents have access to a lively community with accessible transport links and local amenities. The pet-friendly policy, alongside features such as flexible rent payments and short-term leases, make Cheltenham Station the perfect choice for modern living. With our commitment to keeping you engaged through regular resident activities, you will find both a home and a community in our studio apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments Near 19111",
      "seo_description": "Explore studio apartments near 19111 at Cheltenham Station. Experience modern living in Northeast Philly with convenient amenities and vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-j-hampton-moore-school-philadelphia-683",
      "search_query": "apartments near J. Hampton Moore School Philadelphia",
      "category": "School",
      "h1_title": "Apartments Near J. Hampton Moore School",
      "h2_subtitle": "Find convenient apartments near J. Hampton Moore School at Cheltenham Station. Enjoy modern living in a welcoming community.",
      "page_copy": "Cheltenham Station Apartments offers the perfect location for families and individuals seeking quality apartments near J. Hampton Moore School in Philadelphia. With options ranging from studio to spacious two-bedroom layouts, our residences are designed to cater to diverse lifestyle needs, featuring modern upgrades and pet-friendly policies, making it the ideal choice for families and pet owners alike.\n\nSituated just a short drive from J. Hampton Moore School, Cheltenham Station not only provides convenience but also a community where neighbors become friends. Residents enjoy the benefits of vibrant community activities, 24-hour emergency maintenance, and the option of flexible rent payments. Whether you are enrolling your children in school or seeking to enjoy the tranquil atmosphere of Northeast Philadelphia, Cheltenham Station stands as a remarkable place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near J. Hampton Moore School",
      "seo_description": "Discover apartments near J. Hampton Moore School at Cheltenham Station. Modern living with community and convenience in Philadelphia.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-close-to-castor-gardens-middle-school-273",
      "search_query": "apartments close to Castor Gardens Middle School",
      "category": "School",
      "h1_title": "Apartments Close to Castor Gardens Middle",
      "h2_subtitle": "Explore apartments close to Castor Gardens Middle School at Cheltenham Station. Enjoy the perfect blend of comfort and convenience.",
      "page_copy": "Cheltenham Station Apartments provides an excellent living option for families and individuals searching for apartments close to Castor Gardens Middle School. Our community offers a range of floor plans, including studio, one, and two-bedroom units, all equipped with modern amenities to meet diverse needs while ensuring comfort and style. Situated conveniently in Northeast Philadelphia, these apartments are perfect for those who value proximity to education and easy access to community resources.\n\nLiving at Cheltenham Station means enjoying a welcoming environment with engaging resident activities and supportive services like 24-hour emergency maintenance. Our pet-friendly community believes in flexible living, offering options like short-term leases and adaptable rent payments. Make Cheltenham Station your home, and delight in the combination of modern living and an active community just moments away from Castor Gardens Middle School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Castor Gardens Middle",
      "seo_description": "Find apartments close to Castor Gardens Middle School at Cheltenham Station. Enjoy convenient, modern living with a friendly community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "northeast-high-school-nearby-apartments-philadelphia-pa-520",
      "search_query": "Northeast High School nearby apartments Philadelphia PA",
      "category": "School",
      "h1_title": "Nearby Apartments to Northeast High School",
      "h2_subtitle": "Explore apartments near Northeast High School in Philadelphia, PA, at Cheltenham Station. Enjoy the perfect mix of style and convenience.",
      "page_copy": "Cheltenham Station Apartments offers an outstanding location for those seeking apartments close to Northeast High School in Philadelphia, PA. With a variety of floor plans including studios, one-bedroom, and two-bedroom options, our community provides the perfect balance of comfort and modern amenities. Nestled in the heart of Northeast Philadelphia, our apartments are ideal for families or individuals wanting easy access to local schools and community amenities.\n\nLiving at Cheltenham Station means more than just a prime location. It means being part of a vibrant and engaging community that offers regular resident activities, pet-friendly spaces, and the convenience of short-term leases. Whether it's our upgraded kitchens or flexible rent payment options, every detail is designed with your modern lifestyle in mind. Choose Cheltenham Station for a living experience that supports both education and relaxation close to Northeast High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Northeast High School",
      "seo_description": "Discover apartments near Northeast High School in Philadelphia at Cheltenham Station. Enjoy modern amenities and community living tailored for convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-saint-cecilias-school-ne-philadelphia-116",
      "search_query": "apartments near Saint Cecilias School NE Philadelphia",
      "category": "School",
      "h1_title": "Apartments Near Saint Cecilia's School",
      "h2_subtitle": "Discover ideal apartments near Saint Cecilia's School in NE Philadelphia at Cheltenham Station. Experience convenience in our vibrant community.",
      "page_copy": "Cheltenham Station Apartments is the perfect choice for those looking for apartments near Saint Cecilia's School in Northeast Philadelphia. Offering a range of floor plans including studio, one, and two-bedroom options, our community is designed to provide a comfortable and modern living experience. Located conveniently within NE Philadelphia, our apartments cater to families and individuals who value proximity to quality education and community services.\n\nAt Cheltenham Station Apartments, you'll find more than just a home; you'll find a community. Our pet-friendly environment features modern amenities like upgraded kitchens and air conditioning, complemented by short-term lease options and flexible rent payments. Engaging resident activities and 24-hour emergency maintenance services ensure that life here is both enjoyable and hassle-free. Choose Cheltenham Station for unparalleled living close to Saint Cecilia's School in NE Philadelphia.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Cecilia's School",
      "seo_description": "Find comfortable, modern apartments near Saint Cecilia's School in NE Philadelphia at Cheltenham Station. A welcoming community near education and conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-close-to-cedar-grove-christian-academy-738",
      "search_query": "apartments close to CEDAR GROVE CHRISTIAN ACADEMY",
      "category": "School",
      "h1_title": "Apartments Close to Cedar Grove Christian",
      "h2_subtitle": "Find apartments near Cedar Grove Christian Academy at Cheltenham Station. Enjoy modern comforts and a vibrant community in Philadelphia.",
      "page_copy": "Situated in the vibrant community of Northeast Philadelphia, Cheltenham Station Apartments is an ideal residence for those seeking apartments close to Cedar Grove Christian Academy. With floor plans that include studio, one-bedroom, and two-bedroom options, our property caters to diverse living needs while offering modern amenities for comfortable living. Conveniently positioned, these apartments offer a quick commute to the academy, making them a top choice for families and students alike.\n\nEmbrace the friendly ambiance of Cheltenham Station Apartments, featuring a pet-friendly environment and amenities such as upgraded kitchens, air conditioning, and flexible leasing options. Our community hosts engaging resident activities and offers 24-hour emergency maintenance, ensuring that your living experience is enjoyable and stress-free. Opt for Cheltenham Station Apartments to combine convenience with community, all just steps away from Cedar Grove Christian Academy.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cedar Grove Christian",
      "seo_description": "Explore modern apartments near Cedar Grove Christian Academy at Cheltenham Station. Enjoy convenience and community in Philadelphia's Northeast area.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "gospel-of-grace-christian-school-apartments-philadelphia-186",
      "search_query": "Gospel of Grace Christian School apartments Philadelphia",
      "category": "School",
      "h1_title": "Apartments Near Gospel of Grace Christian School",
      "h2_subtitle": "Discover apartments near Gospel of Grace Christian School in Philadelphia at Cheltenham Station. Experience a welcoming community with modern amenities.",
      "page_copy": "Cheltenham Station Apartments is your go-to option for those searching for apartments near Gospel of Grace Christian School in Philadelphia. Our community offers a variety of living spaces, including studio, one-bedroom, and two-bedroom floor plans, tailored to meet the needs of modern families and individuals. Situated in Northeast Philadelphia, our apartments are perfectly located for easy access to Gospel of Grace Christian School and other local amenities.\n\nLife at Cheltenham Station goes beyond just the apartments. Immerse yourself in a vibrant, pet-friendly environment with state-of-the-art features such as upgraded kitchens and air conditioning. Benefit from flexible rent payment options and short-term leases, perfect for accommodating various lifestyles. With engaging resident activities and round-the-clock emergency maintenance, you can enjoy peace of mind and a sense of community while being just moments away from Gospel of Grace Christian School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gospel of Grace Christian School",
      "seo_description": "Find welcoming apartments near Gospel of Grace Christian School in Philadelphia at Cheltenham Station. Enjoy modern amenities in a thriving community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-presentation-bvm-school-ne-philly-932",
      "search_query": "apartments near Presentation BVM School NE Philly",
      "category": "School",
      "h1_title": "Apartments Near Presentation BVM School",
      "h2_subtitle": "Explore ideal apartments near Presentation BVM School in NE Philly at Cheltenham Station. Enjoy community living with modern amenities.",
      "page_copy": "Cheltenham Station Apartments offers an excellent location for those searching for apartments near Presentation BVM School in Northeast Philly. Our community features an array of floor plans including studio, one-bedroom, and two-bedroom options, providing modern living spaces tailored to various needs. Perfectly situated in NE Philadelphia, these apartments ensure a straightforward commute to Presentation BVM School, making them a prime choice for families and individuals devoted to quality education.\n\nOur community at Cheltenham Station Apartments embraces a lifestyle of comfort and convenience. Enjoy pet-friendly living with amenities such as air conditioning, upgraded kitchens, and flexible leasing options. Residents benefit from engaging social activities and reliable 24-hour emergency maintenance services, fostering a worry-free and vibrant living environment. Choose Cheltenham Station for a thriving community experience just steps away from Presentation BVM School in NE Philly.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Presentation BVM School",
      "seo_description": "Discover community-focused apartments near Presentation BVM School in NE Philly at Cheltenham Station. Enjoy a blend of modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-close-to-salus-university-elkins-park-66",
      "search_query": "apartments close to Salus University Elkins Park",
      "category": "School",
      "h1_title": "Apartments Close to Salus University",
      "h2_subtitle": "Discover affordable apartments close to Salus University at Cheltenham Station. Enjoy a supportive community and convenient living in Philadelphia.",
      "page_copy": "Cheltenham Station Apartments is the perfect choice for students and faculty seeking apartments close to Salus University in Elkins Park. Located in Northeast Philadelphia, our vibrant community offers a variety of floor plans, including studio, one-bedroom, and two-bedroom apartments. Enjoy a quick commute to the university while benefiting from modern amenities and comfortable living.\n\nOur apartments feature upgraded kitchens, air conditioning, and flexible leasing options, making them suitable for various lifestyles. As a pet-friendly community, Cheltenham Station also offers engaging resident activities and 24-hour emergency maintenance, ensuring a fulfilling and hassle-free experience. Experience the dynamic community atmosphere and the convenience of living close to Salus University at Cheltenham Station Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Salus University",
      "seo_description": "Find apartments near Salus University in Elkins Park at Cheltenham Station. Enjoy modern amenities and a supportive community in Northeast Philadelphia.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "la-salle-university-nearby-apartments-philadelphia-698",
      "search_query": "La Salle University nearby apartments Philadelphia",
      "category": "School",
      "h1_title": "Nearby Apartments to La Salle University",
      "h2_subtitle": "Explore convenient living with apartments near La Salle University in Philadelphia at Cheltenham Station. Enjoy modern accommodation and a lively community.",
      "page_copy": "Discover the ease of living at Cheltenham Station Apartments, ideally located for those seeking nearby apartments to La Salle University in Philadelphia. Our property offers a variety of living options, including studio, one-bedroom, and two-bedroom apartments, perfect for students and faculty looking for a comfortable home base. Located in Northeast Philadelphia, these modern apartments ensure straightforward access to La Salle University and the many conveniences of city living.\n\nCheltenham Station is a community that combines comfort and convenience. Enjoy amenities such as air-conditioned units, upgraded kitchens, and pet-friendly policies. We offer flexible leasing terms and host engaging resident activities, ensuring a dynamic and accommodating living environment. Experience a vibrant lifestyle with round-the-clock emergency maintenance support, all while being in close proximity to La Salle University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to La Salle University",
      "seo_description": "Discover apartments near La Salle University in Philadelphia at Cheltenham Station. Experience modern amenities and vibrant living in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "community-college-of-philadelphia-nw-regional-center-apartments-970",
      "search_query": "Community College of Philadelphia NW Regional Center apartments",
      "category": "School",
      "h1_title": "Apartments by CCP NW Regional Center",
      "h2_subtitle": "Find comfortable living near the Community College of Philadelphia NW Regional Center at Cheltenham Station. Enjoy a welcoming and modern community setting.",
      "page_copy": "Cheltenham Station Apartments offers the ideal living solution for those searching for apartments near the Community College of Philadelphia NW Regional Center. Our community presents a range of floor plans, including studios, one-bedroom, and two-bedroom options, all thoughtfully designed to cater to different lifestyles. Located in the heart of Northeast Philadelphia, Cheltenham Station ensures a convenient commute to the NW Regional Center, making it a perfect choice for students and staff alike.\n\nOur apartment community embraces the concept of modern living with air-conditioned spaces, updated kitchens, and a welcoming pet-friendly policy. Residents benefit from flexible lease terms and a vibrant atmosphere, complete with engaging activities. Enjoy peace of mind with 24-hour emergency maintenance, all within a supportive community environment. Choose Cheltenham Station Apartments for an accessible and enriching living experience near the Community College of Philadelphia's NW Regional Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by CCP NW Regional Center",
      "seo_description": "Discover apartments near CCP NW Regional Center in Philadelphia at Cheltenham Station. Enjoy modern amenities and a vibrant community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-jeanes-campus-temple-university-hospital-556",
      "search_query": "apartments near Jeanes Campus Temple University Hospital Philadelphia",
      "category": "Hospital",
      "h1_title": "Apartments Near Jeanes Campus Hospital",
      "h2_subtitle": "Find modern apartments near Jeanes Campus Temple University Hospital in Philadelphia. Cheltenham Station offers convenient and comfortable living spaces.",
      "page_copy": "Cheltenham Station Apartments provides a convenient living option for those looking for apartments near Jeanes Campus Temple University Hospital in Philadelphia. Our prime location in Northeast Philadelphia ensures easy access to the hospital, making it a perfect choice for healthcare professionals, students, or anyone needing close proximity. We offer a variety of floor plans, including studio, one-bedroom, and two-bedroom apartments, each equipped with modern amenities to enhance your living experience.\n\nOur community prides itself on creating a vibrant and welcoming environment. Enjoy the comfort of air-conditioned units, updated kitchens, and pet-friendly spaces. With flexible leasing options and active resident engagement programs, Cheltenham Station ensures a dynamic and supportive atmosphere. Experience the peace of mind that comes with 24-hour emergency maintenance in a community that values comfort and convenience near Jeanes Campus Temple University Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jeanes Campus Hospital",
      "seo_description": "Discover modern apartments near Jeanes Campus Temple University Hospital at Cheltenham Station in Philadelphia. Enjoy convenience and comfort in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-close-to-einstein-medical-center-elkins-park-940",
      "search_query": "apartments close to Einstein Medical Center Elkins Park Northeast Philadelphia",
      "category": "Hospital",
      "h1_title": "Apartments Close to Einstein Medical Center",
      "h2_subtitle": "Discover spacious apartments close to Einstein Medical Center in Elkins Park, Northeast Philadelphia. Cheltenham Station provides modern, convenient accommodations.",
      "page_copy": "Cheltenham Station Apartments offers an excellent living experience for those searching for apartments close to Einstein Medical Center Elkins Park in Northeast Philadelphia. Our community is ideally situated to provide easy access to the medical center, making it a top choice for healthcare professionals and anyone needing proximity to work. Choose from a range of floor plans, including studio, one-bedroom, and two-bedroom options, each featuring up-to-date amenities and a comfortable living environment.\n\nExperience the blend of comfort and community at Cheltenham Station. Our apartments come with air conditioning, upgraded kitchens, and pet-friendly policies, ensuring a pleasant and accommodating atmosphere. Residents enjoy flexible lease options and engaging community events, fostering a vibrant living experience. With the convenience of 24-hour emergency maintenance, you can relax and focus on what matters most, all while being close to Einstein Medical Center Elkins Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Einstein Medical Center",
      "seo_description": "Find modern apartments near Einstein Medical Center Elkins Park at Cheltenham Station in Northeast Philadelphia. Enjoy convenience and contemporary comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "cheltenham-station-apartments-near-burholme-park-728",
      "search_query": "cheltenham station apartments near burholme park",
      "category": "Park",
      "h1_title": "Cheltenham Station by Burholme Park",
      "h2_subtitle": "Discover Cheltenham Station Apartments, conveniently located near Burholme Park in Philadelphia. Enjoy modern amenities and vibrant community living.",
      "page_copy": "Cheltenham Station Apartments is your gateway to comfortable living near Burholme Park in Northeast Philadelphia. Nestled in a prime location, our community offers easy access to the lush green spaces and recreational activities available at Burholme Park, making it an ideal spot for nature lovers and those who enjoy outdoor activities. Choose from an array of floor plans, including studio, one-bedroom, and two-bedroom options, each thoughtfully designed with comfort and modernity in mind.\n\nOur community at Cheltenham Station is all about blending lifestyle and convenience. The apartments come equipped with air conditioning, renovated kitchens, and pet-friendly policies, ensuring an inviting atmosphere. With options for short-term leases and flexible rent payments, we adapt to your unique needs. Residents can participate in engaging community activities and enjoy the security of 24-hour emergency maintenance, all while being mere steps from the natural beauty of Burholme Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cheltenham Station by Burholme Park",
      "seo_description": "Explore Cheltenham Station Apartments near Burholme Park, Philadelphia. Modern living spaces with access to park amenities and vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-pennypack-environmental-center-722",
      "search_query": "apartments near pennypack environmental center philadelphia",
      "category": "Park",
      "h1_title": "Apartments Near Pennypack Environmental Center",
      "h2_subtitle": "Explore apartments near Pennypack Environmental Center in Philadelphia. Cheltenham Station offers a perfect blend of nature and modern amenities.",
      "page_copy": "Cheltenham Station Apartments offers a unique opportunity for those seeking housing near the Pennypack Environmental Center in Philadelphia. Situated in Northeast Philadelphia, our community provides an ideal location for nature enthusiasts and those who enjoy the outdoors. With studio, one-bedroom, and two-bedroom floor plans, each apartment is designed with modern amenities to ensure comfort and convenience, just a short drive from the natural beauty of the Pennypack Environmental Center.\n\nResidents of Cheltenham Station enjoy a vibrant community atmosphere, complete with air-conditioned apartments, renovated kitchens, and pet-friendly accommodations. Flexible leasing options cater to various needs, while engaging resident activities foster a lively environment. The benefit of 24-hour emergency maintenance provides peace of mind. Discover the perfect balance of urban living and natural beauty at Cheltenham Station Apartments, conveniently located near the Pennypack Environmental Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pennypack Environmental Center",
      "seo_description": "Find apartments near Pennypack Environmental Center at Cheltenham Station in Philadelphia. Enjoy modern living with access to nature and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "rent-near-pennypack-pavilion-northeast-philadelphia-897",
      "search_query": "rent near pennypack pavilion northeast philadelphia",
      "category": "Park",
      "h1_title": "Rent Near Pennypack Pavilion",
      "h2_subtitle": "Find ideal rental options near Pennypack Pavilion in Northeast Philadelphia. Cheltenham Station provides modern living spaces with great local amenities.",
      "page_copy": "Cheltenham Station Apartments presents an excellent choice for those looking to rent near Pennypack Pavilion in Northeast Philadelphia. Our community offers convenient access to this vibrant area, perfect for individuals seeking both serenity and city life. With a selection of studio, one-bedroom, and two-bedroom floor plans, you can find the space that perfectly fits your lifestyle and enjoy an array of modern amenities designed for comfort and convenience.\n\nLiving at Cheltenham Station means enjoying a community-focused environment with features like air conditioning, upgraded kitchens, and pet-friendly policies. Our residents benefit from flexible lease terms and the convenience of 24-hour emergency maintenance. Engage in community activities or take advantage of our prime location to explore the nearby Pennypack Pavilion. Experience the ideal blend of accessibility and tranquility with rentals at Cheltenham Station Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rent Near Pennypack Pavilion",
      "seo_description": "Discover rentals near Pennypack Pavilion at Cheltenham Station Apartments in Northeast Philadelphia. Enjoy modern amenities and excellent community living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "cheltenham-station-living-close-to-tacony-creek-park-706",
      "search_query": "cheltenham station living close to tacony creek park",
      "category": "Park",
      "h1_title": "Cheltenham Station Living by Tacony Creek Park",
      "h2_subtitle": "Experience Cheltenham Station living, conveniently close to Tacony Creek Park. Enjoy modern amenities in a vibrant Philadelphia community.",
      "page_copy": "Discover the allure of Cheltenham Station Apartments, offering a perfect home base for those wanting to be close to Tacony Creek Park. Located in Northeast Philadelphia, our community provides easy access to this beautiful natural oasis, making it an excellent choice for those who appreciate outdoor activities and serene landscapes. Choose from studio, one-bedroom, or two-bedroom floor plans, each offering the modern comforts you need for a fulfilling lifestyle.\n\nAt Cheltenham Station, living is easy and enjoyable. Our apartments feature air conditioning, updated kitchens, and a pet-friendly environment, creating a welcoming atmosphere for all. With options like short-term leases and flexible rent payments, we accommodate diverse needs and lifestyles. Engage with fellow residents through community events or take peace in knowing 24-hour emergency maintenance is always available. Discover the perfect blend of urban living and nature's charm at Cheltenham Station Apartments, conveniently close to Tacony Creek Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Tacony Creek Park",
      "seo_description": "Enjoy life at Cheltenham Station Apartments near Tacony Creek Park. Modern units with easy park access in a welcoming community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166311",
      "source": "custom",
      "page_item_url": "apartments-near-lorimer-park-philadelphia-county-284",
      "search_query": "apartments near lorimer park philadelphia county",
      "category": "Park",
      "h1_title": "Apartments Near Lorimer Park, Philadelphia",
      "h2_subtitle": "Explore apartments near Lorimer Park in Philadelphia County. Cheltenham Station offers exceptional living with convenient park access.",
      "page_copy": "Welcome to Cheltenham Station Apartments, ideally located for those seeking residences near Lorimer Park in Philadelphia County. Set in the vibrant area of Northeast Philadelphia, our community is a gateway to the scenic beauty of Lorimer Park and offers a perfect balance of nature and urban conveniences. Choose from our stylish studio, one-bedroom, or two-bedroom layouts that feature modern amenities such as air conditioning and upgraded kitchens, designed to enhance your living experience.\n\nEmbrace a lifestyle that includes pet-friendly living spaces and flexible leasing options at Cheltenham Station. Our engaging resident activities and emergency maintenance services foster a supportive community environment. Whether you're a nature lover eager to explore the trails of Lorimer Park or simply prefer a tranquil retreat, Cheltenham Station Apartments provides the perfect home base. Enjoy the convenience of proximity to both serene parks and vibrant city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
      "featured_image_media": {
        "alt_text": "Apartment building exterior with a \"Now Leasing\" banner and blooming tree.",
        "public_id": "01a015d9-5016-70ab-8c44-1619f70c7c90",
        "storage_key": "property/6767906449166311/01a015d9-5016-70ab-8c44-1619f70c7c90.webp",
        "width": 3072,
        "height": 2304
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lorimer Park",
      "seo_description": "Find modern apartments near Lorimer Park at Cheltenham Station, Philadelphia County. Enjoy great amenities and nature access in a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5049"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976235433"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973269"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-N99LTBS2"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://cheltenhamstationapartments.fatwin.com/api/websites/resources/1?x=QmhMai9MTUp3UENzb2ZrdGEwTTlhUVZnZUVDbm9zQWNEcS9Da0Vkd0tJcldDaGh0K3lrMFpaL3kxVXhoa1o5dHNxaURjRStSSmFCSmhwV2taNzJhT1E9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95499d54-43e6-11ef-8607-bb5fa5acbc07"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499d54-43e6-11ef-8607-bb5fa5acbc07/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499d54-43e6-11ef-8607-bb5fa5acbc07/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Im5kYjA4Y2N0eGJMYkNvWXZsZHYxRUE9PSIsInZhbHVlIjoiU3FhMFJmR05FeVowVVAvYTE1MGw3UT09IiwibWFjIjoiN2Q4YTRlMGU0YjQxMjM2YTU1MDAzODM3Mzc0NmUxNDlkZTUxMWZmN2E2OTc5NTliOWM1Y2VkMWIwNmNkOTMzYSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5049",
  "custom_repli_id": "9976235433",
  "custom_realpage_id": "4973269",
  "custom_google_gtm_id": "GTM-N99LTBS2",
  "custom_perq_script_url": "https://cheltenhamstationapartments.fatwin.com/api/websites/resources/1?x=QmhMai9MTUp3UENzb2ZrdGEwTTlhUVZnZUVDbm9zQWNEcS9Da0Vkd0tJcldDaGh0K3lrMFpaL3kxVXhoa1o5dHNxaURjRStSSmFCSmhwV2taNzJhT1E9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95499d54-43e6-11ef-8607-bb5fa5acbc07",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499d54-43e6-11ef-8607-bb5fa5acbc07/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95499d54-43e6-11ef-8607-bb5fa5acbc07/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Im5kYjA4Y2N0eGJMYkNvWXZsZHYxRUE9PSIsInZhbHVlIjoiU3FhMFJmR05FeVowVVAvYTE1MGw3UT09IiwibWFjIjoiN2Q4YTRlMGU0YjQxMjM2YTU1MDAzODM3Mzc0NmUxNDlkZTUxMWZmN2E2OTc5NTliOWM1Y2VkMWIwNmNkOTMzYSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "6b0e521c-4112-4d20-a634-33c595db379b",
  "custom_audioeye_site_hash": "b210521d22c0cac1f2e51d3178eeec36"
};

export const generatedAt = '2026-10-22T20:07:12.682Z';
